"use strict";

var dataTableAwlr;
var dataTableAwlrTmat;
var dataTableOw;
var dataTableArr;
var dataTableAwlrArr;
var dataTableWqms;
var dataTableFlowMeter;
var dataTableAws;
var dataTableVnotch;
var dataTablePiezometer;
var dataTableVibratingWire;
let cctvMarkers = [];
let flowMeterMarkers = [];
let cctvViewer = null;
let cctvViewerLoad = null;

const USE_BATTERY_COLUMN = $("#power-source").val() == "B";
const nameYangDihapus = "Battery";

let map;
let infowindow;
let mapReady = false;
let pendingCctvList = null;
let OrgCode = $("#OrgCode").val();
const CCTV_REFRESH_INTERVAL_MS = 150000; // 2.5 menit

function waitForGoogleMaps(timeoutMs = 15000) {
  return new Promise((resolve, reject) => {
    if (window.google?.maps?.importLibrary) {
      resolve();
      return;
    }

    const startedAt = Date.now();
    const timerId = setInterval(() => {
      if (window.google?.maps?.importLibrary) {
        clearInterval(timerId);
        resolve();
      } else if (Date.now() - startedAt > timeoutMs) {
        clearInterval(timerId);
        reject(new Error("Google Maps API tidak tersedia"));
      }
    }, 100);
  });
}

function isMapReady() {
  return mapReady && map && window.google?.maps;
}

function showMapLoadError(message) {
  const mapEl = document.getElementById("map");
  if (!mapEl) return;

  mapEl.innerHTML = `
    <div class="d-flex align-items-center justify-content-center text-muted p-4" style="min-height: 320px;">
      <div class="text-center">
        <i class="mdi mdi-map-marker-off-outline font-24 d-block mb-2"></i>
        <span>${message}</span>
      </div>
    </div>
  `;
}

function cctvViewerAsset(kind) {
  const card = document.getElementById("card-cctv");
  if (kind === "css") {
    return card?.dataset.viewerCss || "/lib/viewerjs/viewer.min.css";
  }
  return card?.dataset.viewerSrc || "/lib/viewerjs/viewer.min.js";
}

function resolveCctvViewer() {
  if (typeof window.Viewer === "function") return window.Viewer;
  if (typeof module !== "undefined" && typeof module.exports === "function") {
    window.Viewer = module.exports;
    return window.Viewer;
  }
  return null;
}

function ensureCctvViewerCss() {
  const href = cctvViewerAsset("css");
  if (document.querySelector(`link[data-cctv-viewer-css="1"], link[href="${href}"]`)) {
    return;
  }
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.dataset.cctvViewerCss = "1";
  document.head.appendChild(link);
}

function ensureCctvViewer() {
  const existing = resolveCctvViewer();
  if (existing) return Promise.resolve(existing);
  if (cctvViewerLoad) return cctvViewerLoad;

  ensureCctvViewerCss();
  cctvViewerLoad = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = cctvViewerAsset("js");
    script.async = false;
    script.onload = () => {
      const ctor = resolveCctvViewer();
      if (ctor) resolve(ctor);
      else reject(new Error("Viewer.js loaded but window.Viewer is missing"));
    };
    script.onerror = () => {
      cctvViewerLoad = null;
      reject(new Error(`Failed to load Viewer.js from ${script.src}`));
    };
    document.head.appendChild(script);
  });

  return cctvViewerLoad;
}

function localizeCctvViewerToolbar() {
  const labels = {
    "zoom-in": "Perbesar",
    "zoom-out": "Perkecil",
    "one-to-one": "Ukuran asli",
    reset: "Reset",
    prev: "Sebelumnya",
    next: "Berikutnya",
  };

  document.querySelectorAll(".viewer-toolbar [data-viewer-action]").forEach((button) => {
    const action = button.getAttribute("data-viewer-action");
    if (labels[action]) button.setAttribute("title", labels[action]);
  });
}

function destroyCctvViewer() {
  if (cctvViewer) {
    cctvViewer.destroy();
    cctvViewer = null;
  }
  $("#cctv-viewer-source").remove();
}

function initCctvViewer(cctvList, timestamp) {
  destroyCctvViewer();
  if (!Array.isArray(cctvList) || cctvList.length === 0) return;

  const ViewerCtor = resolveCctvViewer();
  if (!ViewerCtor) {
    ensureCctvViewer()
      .then(() => initCctvViewer(cctvList, timestamp))
      .catch((error) => console.error(error));
    return;
  }

  ensureCctvViewerCss();

  const source = document.createElement("div");
  source.id = "cctv-viewer-source";
  source.hidden = true;
  cctvList.forEach((cctv) => {
    const img = document.createElement("img");
    img.src = `${cctv.url}?v=${timestamp}`;
    img.alt = cctv.name || "CCTV";
    source.appendChild(img);
  });
  document.body.appendChild(source);

  const hasGallery = cctvList.length > 1;
  cctvViewer = new ViewerCtor(source, {
    navbar: hasGallery,
    title: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    zoomOnWheel: true,
    zoomOnTouch: true,
    slideOnTouch: false,
    toggleOnDblclick: true,
    loop: hasGallery,
    toolbar: {
      zoomIn: 4,
      zoomOut: 4,
      oneToOne: 4,
      reset: 4,
      prev: hasGallery ? 4 : 0,
      play: 0,
      next: hasGallery ? 4 : 0,
      rotateLeft: 0,
      rotateRight: 0,
      flipHorizontal: 0,
      flipVertical: 0,
    },
    shown: localizeCctvViewerToolbar,
    viewed: localizeCctvViewerToolbar,
  });
}

function openCctvViewer(index) {
  if (!Number.isFinite(index)) return;
  if (cctvViewer) {
    cctvViewer.view(index);
    return;
  }
  ensureCctvViewer()
    .then(() => {
      if (cctvViewer) cctvViewer.view(index);
    })
    .catch((error) => console.error(error));
}

function clearCctvMarkers() {
  cctvMarkers.forEach((marker) => marker.setMap(null));
  cctvMarkers = [];
}

function loadCctvMapMarkers(cctvList) {
  if (!isMapReady() || !Array.isArray(cctvList) || cctvList.length === 0) {
    return;
  }

  clearCctvMarkers();

  if (!infowindow) {
    infowindow = new google.maps.InfoWindow({
      maxWidth: 400,
      minWidth: 280,
    });
  }

  const currTimestamp = new Date().getTime();

  cctvList.forEach((data, index) => {
    if (data.latitude == null || data.longitude == null) {
      return;
    }

    try {
      const contentString = `
        <div class="infowindow-content">
          <h5 class="mb-2 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
          <a class="image-popup-cctv-marker" href="${data.url}?v=${currTimestamp}" title="${data.name}">
            <img class="mb-2 rounded mx-auto d-block img-thumbnail w-100" src="${data.url}?v=${currTimestamp}" alt="${data.name}">
          </a>
        </div>
      `;

      const cctvMarker = new google.maps.Marker({
        position: {
          lat: parseFloat(data.latitude),
          lng: parseFloat(data.longitude),
        },
        map: map,
        icon: {
          url: "/images/cctv-marker.png",
          scaledSize: new google.maps.Size(35, 43),
        },
        title: data.name,
      });

      cctvMarker.addListener("click", () => {
        infowindow.setContent(contentString);
        infowindow.open(map, cctvMarker);

        google.maps.event.addListenerOnce(infowindow, "domready", function () {
          $(".image-popup-cctv-marker")
            .off("click.cctvViewer")
            .on("click.cctvViewer", function (event) {
              event.preventDefault();
              openCctvViewer(index);
            });
        });
      });

      cctvMarkers.push(cctvMarker);
    } catch (err) {
      console.warn("CCTV map marker skipped:", data.name, err);
    }
  });
}

function destroyCctvCarousel() {
  const $carousel = $("#cctv-carousel");
  if ($carousel.length && $carousel.data("owl.carousel")) {
    $carousel.trigger("destroy.owl.carousel");
  }
  if ($.magnificPopup?.instance?.isOpen) {
    $.magnificPopup.instance.close();
  }
}

function renderCctvCarousel(cctvItemsHtml) {
  destroyCctvCarousel();
  $("#card-cctv .card-body").html(
    `<div class="owl-carousel owl-theme" id="cctv-carousel">${cctvItemsHtml}</div>`,
  );

  $("#cctv-carousel").owlCarousel({
    autoplay: true,
    autoplayTimeout: 10000,
    items: 3,
    nav: false,
    lazyLoad: true,
    loop: false,
    margin: 10,
    responsiveClass: true,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
    },
  });

  $("#card-cctv")
    .off("click.cctvViewer")
    .on("click.cctvViewer", ".image-popup", function (event) {
      event.preventDefault();
      openCctvViewer(Number($(this).attr("data-index")));
    });
}

async function loadCctvCarousel(showLoading = true) {
  if ($("#card-cctv").length === 0) {
    return [];
  }

  if (showLoading) {
    destroyCctvCarousel();
    $("#card-cctv .card-body").html(
      '<div class="text-center"><div class="spinner-border avatar-sm text-primary m-auto" role="status"></div></div>',
    );
  }

  try {
    const res = await getData("/Cctv/GetListCctv");
    const result = res.data || [];
    const currTimestamp = new Date().getTime();
    let cctvItemsHtml = "";

    $.each(result, function (index, data) {
      cctvItemsHtml += `
        <div class="item" style="background-image: url('${data.url}?v=${currTimestamp}');">
          <a class="image-title image-popup" data-index="${index}" href="${data.url}?v=${currTimestamp}" title="${data.name}">
            <div class="d-flex justify-content-between align-items-center">
              <span>${data.name}</span>
              <i class="mdi mdi-eye"></i>
            </div>
          </a>
        </div>
      `;
    });

    initCctvViewer(result, currTimestamp);

    if (cctvItemsHtml) {
      renderCctvCarousel(cctvItemsHtml);
    } else {
      $("#card-cctv .card-body").html(
        '<p class="text-muted text-center mb-0">Tidak ada CCTV tersedia.</p>',
      );
    }

    return result;
  } catch (err) {
    console.error("CCTV carousel load failed:", err);
    $("#card-cctv .card-body").html(
      '<div class="alert alert-warning mb-0">Gagal memuat CCTV. Silakan refresh halaman.</div>',
    );
    return [];
  }
}

async function loadCctv(showLoading = true) {
  pendingCctvList = await loadCctvCarousel(showLoading);
  if (isMapReady()) {
    loadCctvMapMarkers(pendingCctvList);
  }
}

function startCctvAutoRefresh() {
  if ($("#card-cctv").length === 0) {
    return;
  }

  setInterval(() => {
    loadCctv(false).catch((err) =>
      console.error("CCTV auto-refresh failed:", err),
    );
  }, CCTV_REFRESH_INTERVAL_MS);
}

var TabelMonitoring = (function () {
  async function initMap() {
    try {
      await waitForGoogleMaps();
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

      map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: parseFloat(mapLatitude), lng: parseFloat(mapLongitude) },
      zoom: parseInt(mapZoom),
      mapTypeId: "hybrid",
      mapId: "4504f8b37365c3d0",
    });

    loadLegend(map);
    fetchMarkers();

    if (totalAwlr > 0) {
      getData(`/Home/GetAwlrLastReading`)
        .then((res) => {
          const classAlert = document.querySelectorAll(
            ".alert-siaga3, .alert-siaga2, .alert-siaga1"
          );

          // Iterate over each element and remove the classes
          classAlert.forEach((element) => {
            classAlert.classList.remove(
              "alert-siaga3",
              "alert-siaga2",
              "alert-siaga1"
            );
          });

          let result = res.data;

          if (result.code == 200) {
            const awlrStations = result.response;
            $("#total-awlr").html(awlrStations.length);

            $.each(awlrStations, function (key, data) {
              let watershedName = "-";
              let awlr_level_class = "";
              let reading_at = "-";
              let status = "-";
              let water_level = "-";
              let debit = "-";
              let isOnline = false;
              let status_online =
                '<span><small class="mdi mdi-circle text-danger"></small> Offline</span>';

              if (data.readingAt != null) {
                var readingAt = moment.parseZone(data.readingAt);
                const currentTime = moment();
                reading_at = `${readingAt
                  .locale("id")
                  .format("D MMMM YYYY HH:mm")} ${data.timeZone}`;

                const diffInMinutes = currentTime.diff(readingAt, "minutes");

                if (Math.abs(diffInMinutes) >= 5) {
                  status_online =
                    '<span><small class="mdi mdi-circle text-success"></small> Online</span>';
                  isOnline = true;
                }
              }

              if (data.watershedName != null) {
                watershedName = data.watershedName;
              }

              if (data.waterLevel != null) {
                water_level = `${data.waterLevel} <sup>${data.unitDisplay}</sup>`;
              }

              if (data.debit != null) {
                debit = `${data.debit} <sup>m3/s</sup>`;
              }

              switch (data.warningStatus) {
                case 0:
                  awlr_level_class = "";
                  status =
                    '<span class="badge bg-success font-10">NORMAL</span>';
                  break;
                case 3:
                  awlr_level_class = "alert-siaga3";
                  status =
                    '<span class="badge bg-warning font-10">WASPADA</span>';
                  break;
                case 2:
                  awlr_level_class = "alert-siaga2";
                  status =
                    '<span class="badge font-10" style="background-color: rgba(247, 160, 2)">SIAGA</span>';
                  break;
                case 1:
                  awlr_level_class = "alert-siaga1";
                  status = '<span class="badge bg-danger font-10">AWAS</span>';
                  break;
                default:
                  awlr_level_class = "";
                  break;
              }

              if (data.latitude && data.longitude) {
                // InfoWindow content
                var contentString = `
                            <div class="table-responsive">
                                <table class="table mb-2 font-12">
                                    <tbody>
                                        <tr>
                                            <td class="px-0 py-2 pt-1 pe-3" colspan="3">
                                                <div class="d-flex align-items-start">
                                                    <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                                    <div class="w-100">
                                                        <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                                        <div class="d-flex align-items-center">
                                                            ${status_online}
                                                            <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                                        <div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="py-1 px-0">Sungai</td>
                                            <td class="py-1 px-2">:</td>
                                            <td class="py-1 px-0">${watershedName}</td>
                                        </tr>
                                        <tr>
                                            <td class="py-1 px-0">Update</td>
                                            <td class="py-1 px-2">:</td>
                                            <td class="py-1 px-0">${reading_at}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-around align-items-center mb-1 reading-text">
                                <div class="col-4 text-center font-14 fw-bold text-dark">
                                    ${water_level}
                                </div>
                                <div class="col-4 text-center font-14 fw-bold text-dark">
                                    ${debit}
                                </div>
                                <div class="col-4 text-center font-15 fw-bold text-dark">
                                    ${status}
                                </div>
                            </div>
                            <div class="d-flex justify-content-around reading-text mb-2">
                                <div class="col-4 text-center font-12 text-nowrap">
                                    TMA
                                </div>
                                <div class="col-4 text-center font-12 text-nowrap">
                                    Debit
                                </div>
                                <div class="col-4 text-center font-12 text-nowrap">
                                    Status
                                </div>
                            </div>
                            <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
                            `;
              }

              if (data.latitude != null && data.longitude != null) {
                // Create a new InfoWindow for each marker
                if (!infowindow) {
                  infowindow = new google.maps.InfoWindow({
                    maxWidth: 400,
                    minWidth: 280,
                  });
                }
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    if (totalArr > 0) {
      getData(`/Home/GetArrLastReading`)
        .then((res) => {
          let result = res.data;
          if (result.code == 200) {
            $("#total-arr").html(result.response.length);

            $.each(result.response, function (key, data) {
              let reading_at = "-";
              let status_online =
                '<span><small class="mdi mdi-circle text-danger"></small> Offline</span>';
              let rainfall_hour = "-";
              let intensity_hour = "-";
              let intensity_hour_icon = "-";

              if (data.rainfallLastHour != null) {
                rainfall_hour = `${data.rainfallLastHour} <sup class="text-muted">mm</sup>`;
              }

              if (data.intensityLastHour != null) {
                intensity_hour = getIntensityName(data.intensityLastHour);
                intensity_hour_icon = getIntensityIconMap(
                  data.intensityLastHour
                );
              }

              if (data.readingAt != null) {
                var readingAt = moment.parseZone(data.readingAt);
                const currentTime = moment();
                reading_at = `${readingAt
                  .locale("id")
                  .format("D MMMM YYYY HH:mm")} ${data.timeZone}`;

                const diffInMinutes = currentTime.diff(readingAt, "minutes");

                if (Math.abs(diffInMinutes) > 5) {
                  status_online =
                    '<span><small class="mdi mdi-circle text-success"></small> Online</span>';
                }
              }

              if (data.latitude && data.longitude) {
                // InfoWindow content
                var contentString = `
                            <div class="table-responsive">
                                <table class="table mb-2 font-12">
                                    <tbody>
                                        <tr>
                                            <td class="px-0 py-2 pt-1" colspan="3">
                                                <div class="d-flex align-items-start">
                                                    <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                                    <div class="w-100">
                                                        <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                                        <div class="d-flex align-items-center">
                                                            ${status_online}
                                                            <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                                        <div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="py-1 px-0">Update</td>
                                            <td class="py-1 px-2">:</td>
                                            <td class="py-1 px-0">${reading_at}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-around align-items-center reading-text">
                                <div class="col-6 text-center font-15 fw-bold text-dark">
                                    ${rainfall_hour}
                                </div>
                                <div class="col-6 text-center font-15 fw-bold text-dark">
                                    ${intensity_hour_icon}
                                </div>
                            </div>
                            <div class="d-flex justify-content-around reading-text mb-3">
                                <div class="col-6 text-center font-12 text-nowrap">
                                    Curah Hujan
                                </div>
                                <div class="col-6 text-center font-12 text-nowrap">
                                    ${intensity_hour}
                                </div>
                            </div>
                            <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
                            `;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    if (totalAwlrArr > 0) {
      getData(`/Home/GetAwlrArrLastReading`)
        .then((res) => {
          let result = res.data;

          if (result.code == 200) {
            $.each(result.response, function (key, data) {
              let awlr_level_class = "";
              let reading_at = "-";
              let status = "-";
              let water_level = "-";
              let debit = "-";
              let status_online =
                '<span><small class="mdi mdi-circle text-danger"></small> Offline</span>';

              let rainfall_hour = "-";
              let intensity_hour = "-";
              let intensity_hour_icon = "-";

              if (data.rainfallLastHour != null) {
                rainfall_hour = `${data.rainfallLastHour} <sup class="text-muted">mm</sup>`;
              }

              if (data.intensityLastHour != null) {
                intensity_hour = getIntensityName(data.intensityLastHour);
                intensity_hour_icon = getIntensityIconMap(
                  data.intensityLastHour
                );
              }

              if (data.readingAt != null) {
                var readingAt = moment.parseZone(data.readingAt);
                const currentTime = moment();
                reading_at = `${readingAt
                  .locale("id")
                  .format("D MMMM YYYY HH:mm")} ${data.timeZone}`;

                const diffInMinutes = currentTime.diff(readingAt, "minutes");

                if (Math.abs(diffInMinutes) > 5) {
                  status_online =
                    '<span><small class="mdi mdi-circle text-success"></small> Online</span>';
                }
              }

              if (data.waterLevel != null) {
                water_level = `${data.waterLevel} <sup>${data.unitDisplay}</sup>`;
              }

              if (data.debit != null) {
                debit = `${data.debit} m<sup>3</sup>/s`;
              }

              switch (data.warningStatus) {
                case 0:
                  awlr_level_class = "";
                  status =
                    '<span class="badge bg-success font-10">NORMAL</span>';
                  break;
                case 3:
                  awlr_level_class = "alert-siaga3";
                  status =
                    '<span class="badge bg-warning font-10">WASPADA</span>';
                  break;
                case 2:
                  awlr_level_class = "alert-siaga2";
                  status =
                    '<span class="badge font-10" style="background-color: rgba(247, 160, 2)">SIAGA</span>';
                  break;
                case 1:
                  awlr_level_class = "alert-siaga1";
                  status = '<span class="badge bg-danger font-10">AWAS</span>';
                  break;
                default:
                  awlr_level_class = "";
                  break;
              }

              if (data.latitude && data.longitude) {
                // InfoWindow content
                var contentString = `
                            <div class="table-responsive">
                                <table class="table mb-1 font-12">
                                    <tbody>
                                        <tr>
                                            <td class="px-0 py-2 pt-1" colspan="3">
                                                <div class="d-flex align-items-start">
                                                    <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                                    <div class="w-100">
                                                        <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                                        <div class="d-flex align-items-center">
                                                            ${status_online}
                                                            <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                                        <div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="py-1 px-0">Update</td>
                                            <td class="py-1 px-2">:</td>
                                            <td class="py-1 px-0">${reading_at}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-around align-items-center reading-text">
                                <div class="col-4 text-center font-15 fw-bold text-dark">
                                    ${water_level}
                                </div>
                                <div class="col-4 text-center font-15 fw-bold text-dark">
                                    <h4>${debit}</h4>
                                </div>
                                <div class="col-4 text-center font-15 fw-bold text-dark">
                                    <h4>${status}</h4>
                                </div>
                            </div>
                            <div class="d-flex justify-content-around reading-text mb-2">
                                <div class="col-4 text-center font-12 text-nowrap">
                                    TMA
                                </div>
                                <div class="col-4 text-center font-12 text-nowrap">
                                    Debit
                                </div>
                                <div class="col-4 text-center font-12 text-nowrap">
                                    Status
                                </div>
                            </div>
                            <div class="d-flex justify-content-around align-items-center reading-text">
                                <div class="col-6 text-center font-15 fw-bold text-dark">
                                    ${rainfall_hour}
                                </div>
                                <div class="col-6 text-center font-15 fw-bold text-dark">
                                    ${intensity_hour_icon}
                                </div>
                            </div>
                            <div class="d-flex justify-content-around reading-text mb-3">
                                <div class="col-6 text-center font-12 text-nowrap">
                                    Curah Hujan
                                </div>
                                <div class="col-6 text-center font-12 text-nowrap">
                                    ${intensity_hour}
                                </div>
                            </div>
                            <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
                            `;

                // Create marker
                // const customAwlrArrMarker = document.createElement("div");
                // customAwlrArrMarker.className = `awlr-arr-marker ${awlr_level_class}`;

                // const awlrArrMarker = new AdvancedMarkerElement({
                //     map,
                //     position: { lat: parseFloat(data.latitude), lng: parseFloat(data.longitude) },
                //     content: customAwlrArrMarker
                // });

                // // Add click listener for each marker
                // awlrArrMarker.addListener("click", () => {
                //     infowindow.setContent(contentString);
                //     infowindow.open({
                //         anchor: awlrArrMarker,
                //         map,
                //     });
                // });
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    if (totalAws > 0) {
      getData(`/Home/GetAwsLastReading`)
        .then((res) => {
          let result = res.data;
          if (result.code == 200) {
            $("#total-aws").html(result.response.length);

            $.each(result.response, function (key, data) {
              let reading_at = "-";
              let status_online =
                '<span><small class="mdi mdi-circle text-danger"></small> Offline</span>';
              let rainfall_hour = "-";
              let intensity_hour = "-";
              let intensity_hour_icon = "-";

              if (data.rainfallLastHour != null) {
                rainfall_hour = `${data.rainfallLastHour} <sup class="text-muted">mm</sup>`;
              }

              if (data.intensityLastHour != null) {
                intensity_hour = getIntensityName(data.intensityLastHour);
                intensity_hour_icon = getIntensityIconMap(
                  data.intensityLastHour
                );
              }

              if (data.readingAt != null) {
                var readingAt = moment.parseZone(data.readingAt);
                const currentTime = moment();
                reading_at = `${readingAt
                  .locale("id")
                  .format("D MMMM YYYY HH:mm")} ${data.timeZone}`;

                const diffInMinutes = currentTime.diff(readingAt, "minutes");

                if (Math.abs(diffInMinutes) > 5) {
                  status_online =
                    '<span><small class="mdi mdi-circle text-success"></small> Online</span>';
                }
              }

              if (data.latitude && data.longitude) {
                var sensorReadings = "";
                if (data.humidity != null) {
                  sensorReadings += `<tr>
                                    <td class="py-1 px-0">Kelembapan</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0"><span class="text-dark fw-semibold">${data.humidity}%</span></td>
                                </tr>`;
                }

                if (data.rainfall != null) {
                  sensorReadings += `<tr>
                                    <td class="py-1 px-0">Curah Hujan</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0"><span class="text-dark fw-semibold">${rainfall_hour}</span> <small class="text-muted">(${intensity_hour})</small></td>
                                </tr>`;
                }

                if (data.pressure != null) {
                  sensorReadings += `<tr>
                                    <td class="py-1 px-0">Tekanan</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0"><span class="text-dark fw-semibold">${data.pressure}</span> <small class="text-muted">MB</small></td>
                                </tr>`;
                }

                if (data.solarRadiation != null) {
                  var sunshineHour = "";

                  if (data.sunshineHour != null) {
                    sunshineHour = `<span class="text-dark fw-semibold">${data.sunshineHour} <small class="text-muted">Jam</small>`;
                  }
                  sensorReadings += `<tr>
                                    <td class="py-1 px-0">Tekanan</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0">
                                        <span class="text-dark fw-semibold">${data.solarRadiation}</span> <small class="text-muted">(W/m2)</small> ${sunshineHour}</span>
                                    </td>
                                </tr>`;
                }

                if (data.windDirection != null) {
                  sensorReadings += `<tr>
                                    <td class="py-1 px-0">Arah Angin</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0">
                                        <span class="text-dark fw-semibold me-1">${data.windDirection}&deg;</span>
                                        <small>
                                            <span style="transform: rotate(${data.windDirection}deg);"><i class="mdi mdi-navigation"></i></span>
                                            <span>${data.windDirectionStatus}</span>
                                        </small>
                                    </td>
                                </tr>`;
                }

                if (data.temperature != null) {
                  sensorReadings += `<tr>
                                    <td class="py-1 px-0">Suhu</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0"><span class="text-dark fw-semibold">${data.temperature}</span> <small class="text-muted">&deg;C</small></td>
                                </tr>`;
                }

                if (data.windSpeed != null) {
                  sensorReadings += `<tr>
                                    <td class="py-1 px-0">Kec. Angin</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0"><span class="text-dark fw-semibold">${data.windSpeed}</span> <small class="text-muted">km/h</small></td>
                                </tr>`;
                }

                if (data.evaporation != null) {
                  sensorReadings += `<tr>
                                    <td class="py-1 px-0"> Tinggi Penguapan</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0"><span class="text-dark fw-semibold">Tinggi ${data.evaporation}</span> <small class="text-muted">mm</small></td>
                                </tr>`;
                }

                // InfoWindow content
                var contentString = `
                            <div class="table-responsive">
                                <table class="table mb-2 font-12">
                                    <tbody>
                                        <tr>
                                            <td class="px-0 py-2 pt-1" colspan="3">
                                                <div class="d-flex align-items-start">
                                                    <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                                    <div class="w-100">
                                                        <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                                        <div class="d-flex align-items-center">
                                                            ${status_online}
                                                            <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                                        <div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="py-1 px-0">Update</td>
                                            <td class="py-1 px-2">:</td>
                                            <td class="py-1 px-0">${reading_at}</td>
                                        </tr>
                                        ${sensorReadings}
                                    </tbody>
                                </table>
                            </div>
                            <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
                            `;

                // Create marker
                // const customAwsMarker = document.createElement("div");
                // customAwsMarker.className = `aws-marker`;

                // const awsMarker = new AdvancedMarkerElement({
                //     map,
                //     position: { lat: parseFloat(data.latitude), lng: parseFloat(data.longitude) },
                //     content: customAwsMarker
                // });

                // // Add click listener for each marker
                // awsMarker.addListener("click", () => {
                //     infowindow.setContent(contentString);
                //     infowindow.open({
                //         anchor: awsMarker,
                //         map,
                //     });
                // });
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    if (totalFlowMeter > 0) {
      getData(`/Home/GetFlowMeterLastReading`)
        .then((res) => {
          flowMeterMarkers.forEach((marker) => marker.setMap(null));
          flowMeterMarkers = []; // Reset markers array

          let result = res.data;

          if (result.code == 200) {
            $.each(result.response, function (key, data) {
              let watershedName = "-";
              let reading_at = "-";
              let debit_1jam = "-";
              let well_depth = "-";
              let isOnline = false;
              let status_online =
                '<span><small class="mdi mdi-circle text-danger"></small> Offline</span>';

              if (data.readingAt != null) {
                var readingAt = moment.parseZone(data.readingAt);
                const currentTime = moment();
                reading_at = `${readingAt
                  .locale("id")
                  .format("D MMMM YYYY HH:mm")} ${data.timeZone}`;

                const diffInMinutes = currentTime.diff(readingAt, "minutes");

                if (Math.abs(diffInMinutes) >= 5) {
                  status_online =
                    '<span><small class="mdi mdi-circle text-success"></small> Online</span>';
                  isOnline = true;
                }
              }

              if (data.watershedName != null) {
                watershedName = data.watershedName;
              }

              if (data.flowHour != null) {
                debit_1jam = `${data.flowHour} <sup>m<sup>3</sup>/s</sup>`;
              }

              if (data.latitude && data.longitude) {
                // InfoWindow content
                var contentString = `
                            <div class="table-responsive">
                                <table class="table mb-2 font-12">
                                    <tbody>
                                        <tr>
                                            <td class="px-0 py-2 pt-1 pe-3" colspan="3">
                                                <div class="d-flex align-items-start">
                                                    <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                                    <div class="w-100">
                                                        <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                                        <div class="d-flex align-items-center">
                                                            ${status_online}
                                                            <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                                        <div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="py-1 px-0">Sungai</td>
                                            <td class="py-1 px-2">:</td>
                                            <td class="py-1 px-0">${watershedName}</td>
                                        </tr>
                                        <tr>
                                            <td class="py-1 px-0">Update</td>
                                            <td class="py-1 px-2">:</td>
                                            <td class="py-1 px-0">${reading_at}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-around align-items-center mb-1 reading-text">
                                <div class="col-4 text-center font-14 fw-bold text-dark">
                                    ${debit_1jam}
                                </div>
                                <div class="col-4 text-center font-15 fw-bold text-dark">
                                    ${well_depth}
                                </div>
                            </div>
                            <div class="d-flex justify-content-around reading-text mb-2">
                                <div class="col-4 text-center font-12 text-nowrap">
                                    Kedalaman Sumur
                                </div>
                                <div class="col-4 text-center font-12 text-nowrap">
                                    Debit
                                </div>
                            </div>
                            <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
                            `;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    let colors = [
      "#3cb44b",
      "#e6194b",
      "#ffe119",
      "#4363d8",
      "#f58231",
      "#911eb4",
      "#46f0f0",
      "#f032e6",
      "#bcf60c",
      "#fabebe",
      "#008080",
      "#e6beff",
      "#9a6324",
      "#fffac8",
      "#800000",
      "#aaffc3",
      "#808000",
      "#ffd8b1",
      "#000075",
    ];

    // if (!infowindow) {
    //     infowindow = new google.maps.InfoWindow({
    //         maxWidth: 400,
    //         minWidth: 150
    //     });
    // }

    let colorIndex = 0;

    getData(`/RiverArea/GetAllRiverArea`)
      .then((res) => {
        let result = res.data;
        if (result.code == 200) {
          $.each(result.response, function (key, river_area) {
            if (river_area.shpFile != null && river_area.shpFile != "") {
              $.getJSON(
                `/data/watersheds/${river_area.organizationCode}/${river_area.shpFile}`,
                function (data) {
                  let geoJsonObject;
                  let currentColor = colors[colorIndex % colors.length]; // Pilih warna untuk file ini
                  colorIndex++; // Siapkan warna berikutnya untuk file berikutnya

                  // Buat layer terpisah untuk setiap file
                  const layer = new google.maps.Data();

                  for (let key in data.objects) {
                    if (data.objects.hasOwnProperty(key)) {
                      geoJsonObject = topojson.feature(data, data.objects[key]);
                      // Tambahkan GeoJSON ke layer baru
                      layer.addGeoJson(geoJsonObject);
                    }
                  }

                  // Atur gaya untuk layer ini
                  layer.setStyle(function (feature) {
                    return {
                      fillColor: currentColor,
                      fillOpacity: 0.3,
                      strokeColor: "#222",
                      strokeWeight: 1.5,
                      strokeOpacity: 0.3,
                    };
                  });

                  // Tambahkan layer ke peta
                  layer.setMap(map);
                }
              );
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });

      mapReady = true;
      if (pendingCctvList) {
        loadCctvMapMarkers(pendingCctvList);
      }
    } catch (err) {
      mapReady = false;
      console.error("Map init failed:", err);
      showMapLoadError("Peta tidak dapat dimuat. Data tabel dan CCTV tetap tersedia.");
    }
  }
  // var initMap = function () {
  // const map = L.map('map', {a
  //     center: [parseFloat(mapLatitude), parseFloat(mapLongitude)],
  //     zoom: mapZoom,
  //     maxZoom: 18,
  //     layers: [cctvMarker, awlrMarker, arrMarker, awsMarker]
  // });

  // map.attributionControl.setPrefix(false);

  // new L.basemapsSwitcher([
  // {
  //     layer: L.mapboxGL({
  //         accessToken: 'pk.eyJ1IjoiaGFuZHlhc3dhbiIsImEiOiJjbDY3YmNmcGgwODAxM2R0YjZzY3ZkN3M5In0.7aDstmvWZvOmZIwyPfMB4g',
  //         style: 'mapbox://styles/mapbox/streets-v11',
  //         attribution: `&copy;${new Date().getFullYear()} ${organizationName} | Higertech`
  //     }).addTo(map), //DEFAULT MAP
  //     icon: '/images/basemaps/basemap-grayscale.jpg',
  //     name: 'Grayscale'
  // },
  // {
  //     layer: L.mapboxGL({
  //         accessToken: 'pk.eyJ1IjoiaGFuZHlhc3dhbiIsImEiOiJjbDY3YmNmcGgwODAxM2R0YjZzY3ZkN3M5In0.7aDstmvWZvOmZIwyPfMB4g',
  //         style: 'mapbox://styles/mapbox/satellite-streets-v12',
  //         attribution: `${organizationName} &copy;${new Date().getFullYear()}`
  //     }),
  //     icon: '/images/basemaps/basemap-satellite.jpg',
  //     name: 'Satellite'
  // },
  // {
  //     layer: L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
  //         attribution: `${organizationName} &copy;${new Date().getFullYear()}`
  //     }),
  //     icon: '/images/basemaps/world-imagery.jpg',
  //     name: 'W.Imagery'
  // }
  // ], { position: 'topright' }).addTo(map);

  // const overlays = {
  //     'Perangkat CCTV': cctvMarker,
  //     'Pos Duga Air': awlrMarker,
  //     'Pos Curah Hujan': arrMarker,
  //     'Pos Klimatologi': awsMarker
  // };

  // const layerControl = L.control.layers(null, overlays).addTo(map);

  // // Create a "Home" button
  // var homeButton = L.easyButton('fa-home', function(btn, map){
  //     map.setView([parseFloat(mapLatitude), parseFloat(mapLongitude)], mapZoom);
  // }).addTo(map);

  // L.TopoJSON = L.GeoJSON.extend({
  //     addData: function (data) {
  //     var geojson, key;
  //     if (data.type === "Topology") {
  //         for (key in data.objects) {
  //         if (data.objects.hasOwnProperty(key)) {
  //             geojson = topojson.feature(data, data.objects[key]);
  //             L.GeoJSON.prototype.addData.call(this, geojson);
  //         }
  //         }
  //         return this;
  //     }
  //     L.GeoJSON.prototype.addData.call(this, data);
  //     return this;
  //     }
  // });

  // L.topoJson = function (data, options) {
  //     return new L.TopoJSON(data, options);
  // };

  // async function getGeoData(url) {
  //     let response = await fetch(url);
  //     let data = await response.json();
  //     return data;
  // }

  // const colors = [
  //     '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231',
  //     '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe',
  //     '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000',
  //     '#aaffc3', '#808000', '#ffd8b1', '#000075', '#ff6f61',
  //     '#6a0572', '#a6cee3', '#1f78b4', '#b2df8a'
  // ];

  // let i = 0;

  // getData(`/RiverArea/GetAllRiverArea`).then(res => {
  //     let result = res.data;
  //     if(result.code == 200) {
  //         $.each(result.response, function (key, river_area) {
  //             if(river_area.shpFile != null && river_area.shpFile != '') {
  //                 getGeoData(`/uploads/watersheds/${river_area.organizationCode}/${river_area.shpFile}`).then(data => {
  //                     var geojsonLayer = L.topoJson(null, {
  //                         onEachFeature: function(feature, layer) {
  //                             console.log(feature.properties)
  //                             if (feature.properties.NAMA_DAS != null && feature.properties.NAMA_DAS != '') {
  //                                 layer.bindTooltip(showDetailDas(`WS ${river_area.name}`, feature.properties),
  //                                 {
  //                                     direction: 'right',
  //                                     permanent: false,
  //                                     sticky: true,
  //                                     offset: [10, 0],
  //                                     opacity: 0.9,
  //                                     className: 'leaflet-tooltip-own'
  //                                 }).openTooltip();

  //                                 layer.setStyle({fill: true, stroke: true, color: '#502909', fillColor: colors[i], weight: 1, fillOpacity: 0.2 });

  //                                 layer.on("mouseout", function() {
  //                                     layer.setStyle({fillOpacity: 0.2, weight: 1})
  //                                 });
  //                                 layer.on("mouseover", function() {
  //                                     layer.setStyle({fillOpacity: 0.5, weight: 1.5})

  //                                 });
  //                             } else {
  //                                 layer.setStyle({fill: false, stroke: false });
  //                             }
  //                             i++;
  //                             if (i > 24) i = 0;
  //                         }
  //                     }).addTo(map);
  //                     geojsonLayer.addData(data);
  //                     layerControl.addOverlay(geojsonLayer, `DAS WS ${river_area.name}`);
  //                 });
  //             }
  //         });
  //     }
  // }).catch(err => {
  //     console.log(err.response)
  // })

  // function showDetailDas(river_area, properties) {
  //     var panelContent = `<p style="color: #fcfcfc;font-size: 0.55rem;margin: 0;">${river_area}</p>
  //         <h5 style="font-size: 0.75rem;margin: 3px 0;"><span style="color: #0ECAF0;">#${properties.KODE_DAS}: </span> <span style="color: #FFC10A;">${properties.NAMA_DAS}</span></h5>
  //     `;
  //     return panelContent;
  // }

  // getData(`/Home/GetAwsLastReading`).then(res => {
  //     let result = res.data

  //     if (result.code == 200) {
  //         awsMarker.clearLayers();
  //         $.each(result.response, function (key, data) {
  //             let aws_intensity = '';

  //             // switch (data.warningStatus) {
  //             //     case 'Normal':
  //             //         awlr_level_class = '';
  //             //         break;
  //             //     case 'Siaga 3':
  //             //         awlr_level_class = 'alert-siaga3';
  //             //         break;
  //             //     case 'Siaga 2':
  //             //         awlr_level_class = 'alert-siaga2';
  //             //         break;
  //             //     case 'Siaga 1':
  //             //         awlr_level_class = 'alert-siaga1';
  //             //         break;
  //             //     default:
  //             //         awlr_level_class = '';
  //             //         break;
  //             // }

  //             if (data.latitude && data.longitude) {
  //                 var customIcon = L.divIcon({
  //                     iconSize: new L.Point(40, 20),
  //                     iconAnchor: new L.Point(20, 20),
  //                     html:  `<div class="ts-marker-wrapper"><a href="javascript:void(0)" class="ts-marker ts-aws" data-ts-id="64" data-ts-ln="60" style="outline: none;"><div class="ts-marker__title">${data.name}</div><div class="ts-marker__feature ts-marker__feature__red ${aws_intensity}"><i class="bi bi-cloud-haze2-fill"></i></div></a></div>`
  //                 });

  //                 var stationMarker = L.marker([data.latitude, data.longitude], {
  //                     icon: customIcon,
  //                 }).bindPopup(createDetailPanelStation(data)).addTo(awsMarker);

  //                 // Add a custom attribute to the marker to associate it with the corresponding div
  //                 stationMarker.options.id = data.id;
  //             }
  //         });
  //     }
  // }).catch(err => {
  //     console.log(err.response)
  // });
  // }

  var initDataTable = function () {
    $.fn.dataTable.ext.errMode = "none";

    // =============== VARIABLE COLUMNS DATATABLE =================== //
    var awlrColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-nowrap",
        render: function (data, type, row) {
          if (row.deviceStatus == "offline") {
            return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
          }

          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "deviceId",
        name: "deviceId",
        className: "text-center",
        render: function (data, type, row) {
          return `<span class="badge badge-outline-blue rounded-1 ms-1">${data}</span>`;
        },
      },
      {
        data: "regencyName",
        name: "regencyName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          // Mengambil hasil dari fungsi-fungsi yang diinginkan
          const regency = setRegencyName(data);
          const district = setDistrictName(row.districtName);
          const village = setVillageName(row.villageName);

          // Membuat array dari hasil dan menyaring nilai kosong
          const locations = [regency, district, village].filter(Boolean);

          // Menggabungkan hasil dengan koma
          return `<small>${locations.join("</small>, <small>")}</small>`;
        },
      },
      {
        data: "riverAreaName",
        name: "riverAreaName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "watershedName",
        name: "watershedName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      {
        data: "waterLevel",
        name: "waterLevel",
        className: "text-center text-nowrap",
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).removeClass("bg-normal");
          $(td).removeClass("bg-siaga3");
          $(td).removeClass("bg-siaga2");
          $(td).removeClass("bg-siaga1");
          $(td).removeClass("bg-nostatus");

          if (rowData.unitSensor != "cmdpl" && rowData.unitSensor != "mdpl") {
            if (rowData.waterLevel != null) {
              if(organizationCode == 'ORG009' && cellData < 0) {
                $(td).addClass('bg-awlr-minus');
                return;
              }
              switch (rowData.warningStatus) {
                case 0:
                  $(td).addClass("bg-normal");
                  break;

                case 3:
                  $(td).addClass("bg-siaga3");
                  break;

                case 2:
                  $(td).addClass("bg-siaga2");
                  break;

                case 1:
                  $(td).addClass("bg-siaga1");
                  break;
                default:
                  $(td).addClass("bg-nostatus");
                  break;
              }
            }
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          if (row.waterLevelElevation != null) {
            return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${row.waterLevelElevation} <small style="margin-left: 3px;">mdpl</small></span>`;
          }

          let note = '';
          if(organizationCode == 'ORG009' && data < 0) {
            note = '<br/><small class="text-muted fst-italic">*) Dibawah Mercu</small>';
          }

          return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${data} <small style="margin-left: 3px;">${row.unitDisplay}</small></span>${note}`;
        },
      },
      {
        data: "debit",
        name: "debit",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return data;
        },
      },
      { data: "battery", name: "Battery", className: "text-center" },
    ];
    // }

    // Request Meeting Pak irwan dengan bwskal1 12-feb-2025
    if (organizationCode == "ORG006") {
      awlrColumn = [
        { data: null },
        {
          data: "name",
          name: "name",
          className: "text-nowrap",
          render: function (data, type, row) {
            if (row.deviceStatus == "offline") {
              return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
            }

            return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
          },
        },
        {
          data: "deviceId",
          name: "deviceId",
          className: "text-center",
          render: function (data, type, row) {
            return `<span class="badge badge-outline-blue rounded-1 ms-1">${data}</span>`;
          },
        },
        {
          data: "regencyName",
          name: "regencyName",
          render: function (data, type, row) {
            if (data == null) {
              return '<p class="text-center m-0">-</p>';
            }

            // Mengambil hasil dari fungsi-fungsi yang diinginkan
            const regency = setRegencyName(data);
            const district = setDistrictName(row.districtName);
            const village = setVillageName(row.villageName);

            // Membuat array dari hasil dan menyaring nilai kosong
            const locations = [regency, district, village].filter(Boolean);

            // Menggabungkan hasil dengan koma
            return `<small>${locations.join("</small>, <small>")}</small>`;
          },
        },
        {
          data: "riverAreaName",
          name: "riverAreaName",
          render: function (data, type, row) {
            if (data == null) {
              return '<p class="text-center m-0">-</p>';
            }

            return setUppercase(data);
          },
        },
        {
          data: "watershedName",
          name: "watershedName",
          render: function (data, type, row) {
            if (data == null) {
              return '<p class="text-center m-0">-</p>';
            }

            return setUppercase(data);
          },
        },
        {
          data: "readingAt",
          name: "readingAt",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data != null) {
              return `${moment
                .parseZone(data)
                .locale("id")
                .format("D MMMM YYYY")}`;
            }

            return "-";
          },
        },
        {
          data: "readingAt",
          name: "readingAt",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data != null) {
              return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
            }

            return "-";
          },
        },
        {
          data: "waterLevel",
          name: "waterLevel",
          className: "text-center text-nowrap",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).removeClass("bg-normal");
            $(td).removeClass("bg-siaga3");
            $(td).removeClass("bg-siaga2");
            $(td).removeClass("bg-siaga1");
            $(td).removeClass("bg-nostatus");

            if (rowData.unitSensor != "cmdpl" && rowData.unitSensor != "mdpl") {
              if (rowData.waterLevel != null) {
                switch (rowData.warningStatus) {
                  case 0:
                    $(td).addClass("bg-normal");
                    break;

                  case 3:
                    $(td).addClass("bg-siaga3");
                    break;

                  case 2:
                    $(td).addClass("bg-siaga2");
                    break;

                  case 1:
                    $(td).addClass("bg-siaga1");
                    break;
                  default:
                    $(td).addClass("bg-nostatus");
                    break;
                }
              }
            }
          },
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${data} <small style="margin-left: 3px;">${row.unitDisplay}</small></span>`;
          },
        },
        {
          data: "waterLevelSensor",
          name: "waterLevelSensor",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return data + ` <small>${row.unitSensor}</small>`;
          },
        },
        {
          data: "waterLevelElevation",
          name: "waterLevelElevation",
          className: "text-center text-nowrap",
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).removeClass("bg-normal");
            $(td).removeClass("bg-siaga3");
            $(td).removeClass("bg-siaga2");
            $(td).removeClass("bg-siaga1");
            $(td).removeClass("bg-nostatus");

            if (rowData.unitSensor == "cmdpl" && rowData.unitSensor == "mdpl") {
              if (rowData.waterLevel != null) {
                switch (rowData.warningStatus) {
                  case 0:
                    $(td).addClass("bg-normal");
                    break;

                  case 3:
                    $(td).addClass("bg-siaga3");
                    break;

                  case 2:
                    $(td).addClass("bg-siaga2");
                    break;

                  case 1:
                    $(td).addClass("bg-siaga1");
                    break;
                  default:
                    $(td).addClass("bg-nostatus");
                    break;
                }
              }
            }
          },
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${data} <small style="margin-left: 3px;">mdpl</small></span>`;
          },
        },

        {
          data: "debit",
          name: "debit",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return data;
          },
        },
        { data: "battery", name: "Battery", className: "text-center" },
      ];
    }

    var awlrTmatColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-nowrap",
        render: function (data, type, row) {
          if (row.deviceStatus == "offline") {
            return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
          }

          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "deviceId",
        name: "deviceId",
        className: "text-center",
        render: function (data, type, row) {
          return `<span class="badge badge-outline-blue rounded-1 ms-1">${data}</span>`;
        },
      },
      {
        data: "regencyName",
        name: "regencyName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          // Mengambil hasil dari fungsi-fungsi yang diinginkan
          const regency = setRegencyName(data);
          const district = setDistrictName(row.districtName);
          const village = setVillageName(row.villageName);

          // Membuat array dari hasil dan menyaring nilai kosong
          const locations = [regency, district, village].filter(Boolean);

          // Menggabungkan hasil dengan koma
          return `<small>${locations.join("</small>, <small>")}</small>`;
        },
      },
      {
        data: "riverAreaName",
        name: "riverAreaName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "watershedName",
        name: "watershedName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      {
        data: "wellDepth",
        name: "wellDepth",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `<span class="text-dark fw-semibold">${data} <small class="text-muted">${row.wellDepthUnit}</small></span>`;
          }

          return "-";
        },
      },
      {
        data: "waterLevel",
        name: "waterLevel",
        className: "text-center text-nowrap",
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).removeClass("bg-normal");
          $(td).removeClass("bg-siaga3");
          $(td).removeClass("bg-siaga2");
          $(td).removeClass("bg-siaga1");
          $(td).removeClass("bg-nostatus");

          if (rowData.unitSensor != "cmdpl" && rowData.unitSensor != "mdpl") {
            if (rowData.waterLevel != null) {
              switch (rowData.warningStatus) {
                case 0:
                  $(td).addClass("bg-normal");
                  break;

                case 3:
                  $(td).addClass("bg-siaga3");
                  break;

                case 2:
                  $(td).addClass("bg-siaga2");
                  break;

                case 1:
                  $(td).addClass("bg-siaga1");
                  break;
                default:
                  $(td).addClass("bg-nostatus");
                  break;
              }
            }
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          if (row.waterLevelElevation != null) {
            return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${row.waterLevelElevation} <small style="margin-left: 3px;">mdpl</small></span>`;
          }

          return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${data} <small style="margin-left: 3px;">${row.unitDisplay}</small></span>`;
        },
      },
      {
        data: "waterLevel",
        name: "waterLevel",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data == null || row.wellDepth == null) {
            return "-";
          }

          const dat = (row.wellDepth - data).toFixed(2);

          if (row.waterLevelElevation != null) {
            return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${row.waterLevelElevation} <small style="margin-left: 3px;">mdpl</small></span>`;
          }

          return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${dat} <small style="margin-left: 3px;">${row.unitDisplay}</small></span>`;
        },
      },
      { data: "battery", name: "Battery", className: "text-center" },
    ];

    if(organizationCode == "ORG084") {
      awlrTmatColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-nowrap",
        render: function (data, type, row) {
          if (row.deviceStatus == "offline") {
            return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
          }

          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "deviceId",
        name: "deviceId",
        className: "text-center",
        render: function (data, type, row) {
          return `<span class="badge badge-outline-blue rounded-1 ms-1">${data}</span>`;
        },
      },
      {
        data: "regencyName",
        name: "regencyName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          // Mengambil hasil dari fungsi-fungsi yang diinginkan
          const regency = setRegencyName(data);
          const district = setDistrictName(row.districtName);
          const village = setVillageName(row.villageName);

          // Membuat array dari hasil dan menyaring nilai kosong
          const locations = [regency, district, village].filter(Boolean);

          // Menggabungkan hasil dengan koma
          return `<small>${locations.join("</small>, <small>")}</small>`;
        },
      },
      {
        data: "riverAreaName",
        name: "riverAreaName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "watershedName",
        name: "watershedName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      {
        data: "wellDepth",
        name: "wellDepth",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `<span class="text-dark fw-semibold">${data} <small class="text-muted">${row.wellDepthUnit}</small></span>`;
          }

          return "-";
        },
      },
      {
        data: "waterLevel",
        name: "waterLevel",
        className: "text-center text-nowrap",
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).removeClass("bg-normal");
          $(td).removeClass("bg-siaga3");
          $(td).removeClass("bg-siaga2");
          $(td).removeClass("bg-siaga1");
          $(td).removeClass("bg-nostatus");

          if (rowData.unitSensor != "cmdpl" && rowData.unitSensor != "mdpl") {
            if (rowData.waterLevel != null) {
              switch (rowData.warningStatus) {
                case 0:
                  $(td).addClass("bg-normal");
                  break;

                case 3:
                  $(td).addClass("bg-siaga3");
                  break;

                case 2:
                  $(td).addClass("bg-siaga2");
                  break;

                case 1:
                  $(td).addClass("bg-siaga1");
                  break;
                default:
                  $(td).addClass("bg-nostatus");
                  break;
              }
            }
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          if (row.waterLevelElevation != null) {
            return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${row.waterLevelElevation} <small style="margin-left: 3px;">mdpl</small></span>`;
          }

          return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${data} <small style="margin-left: 3px;">${row.unitDisplay}</small></span>`;
        },
      },
      {
        data: "waterLevel",
        name: "waterLevel",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data == null || row.wellDepth == null) {
            return "-";
          }

          const dat = (row.wellDepth - data).toFixed(2);

          if (row.waterLevelElevation != null) {
            return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${row.waterLevelElevation} <small style="margin-left: 3px;">mdpl</small></span>`;
          }

          return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${dat} <small style="margin-left: 3px;">${row.unitDisplay}</small></span>`;
        },
      },
      {
        data: "ph",
        name: "ph",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `<span class="text-dark fw-semibold">${data}</span>`;
          }

          return "-";
        },
      },
        {
        data: "temperature",
        name: "temperature",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `<span class="text-dark fw-semibold">${data} <small class="text-muted">°C</small></span>`;
          }

          return "-";
        },
      },
      { data: "battery", name: "Battery", className: "text-center" },
    ];
    }

    var awlrArrColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-nowrap",
        render: function (data, type, row) {
          if (row.deviceStatus == "offline") {
            return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
          }

          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "deviceId",
        name: "deviceId",
        className: "text-center",
        render: function (data, type, row) {
          return `<span class="badge badge-outline-blue rounded-1 ms-1">${data}</span>`;
        },
      },
      {
        data: "watershedName",
        name: "watershedName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return data;
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      {
        data: "waterLevel",
        name: "waterLevel",
        className: "text-center text-nowrap",
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).removeClass("bg-normal");
          $(td).removeClass("bg-siaga3");
          $(td).removeClass("bg-siaga2");
          $(td).removeClass("bg-siaga1");
          $(td).removeClass("bg-nostatus");

          if (rowData.unitSensor != "cmdpl" && rowData.unitSensor != "mdpl") {
            if (rowData.waterLevel != null) {
              switch (rowData.warningStatus) {
                case 0:
                  $(td).addClass("bg-normal");
                  break;

                case 3:
                  $(td).addClass("bg-siaga3");
                  break;

                case 2:
                  $(td).addClass("bg-siaga2");
                  break;

                case 1:
                  $(td).addClass("bg-siaga1");
                  break;
                default:
                  $(td).addClass("bg-nostatus");
                  break;
              }
            }
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data} ${row.unitDisplay}</span>`;
        },
      },
      {
        data: "debit",
        name: "debit",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="fw-semibold">${data}</span>`;
        },
      },
      {
        data: "rainfallLastHour",
        name: "rainfallLastHour",
        className: "text-center",
        createdCell: function (td, cellData, rowData, row, col) {
          switch (rowData.intensityLastHour) {
            case 0:
              $(td).addClass("bg-berawan");
              break;

            case 1:
              $(td).addClass("bg-hujan-ringan");
              break;

            case 2:
              $(td).addClass("bg-hujan-sedang");
              break;

            case 3:
              $(td).addClass("bg-hujan-lebat");
              break;
            case 4:
              $(td).addClass("bg-hujan-sangat-lebat");
              break;
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "intensityLastHour",
        name: "intensityLastHour",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          var intensity_status = "-";

          switch (data) {
            case 0:
              intensity_status = "Tidak Ada Hujan";
              break;
            case 1:
              intensity_status = "Hujan Ringan";
              break;
            case 2:
              intensity_status = "Hujan Sedang";
              break;
            case 3:
              intensity_status = "Hujan Lebat";
            case 4:
              intensity_status = "Hujan Sangat Lebat";
              break;
            default:
              intensity_status = "";
              break;
          }

          return `
                            <div class="d-flex justify-content-center align-items-center">
                                ${getIntensityIcon(data)}
                            </div>
                        `;
          // return `<span class="text-dark fw-semibold">${intensity_status}</span>`;
        },
      },
      { data: "battery", name: "Battery", className: "text-center" },
    ];

    var arrColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-nowrap",
        render: function (data, type, row) {
          if (row.deviceStatus == "offline") {
            return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
          }

          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "deviceId",
        name: "deviceId",
        className: "text-center",
        render: function (data, type, row) {
          return `<span class="badge badge-outline-blue rounded-1 ms-1">${data}</span>`;
        },
      },
      {
        data: "regencyName",
        name: "regencyName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          // Mengambil hasil dari fungsi-fungsi yang diinginkan
          const regency = setRegencyName(data);
          const district = setDistrictName(row.districtName);
          const village = setVillageName(row.villageName);

          // Membuat array dari hasil dan menyaring nilai kosong
          const locations = [regency, district, village].filter(Boolean);

          // Menggabungkan hasil dengan koma
          return `<small>${locations.join("</small>, <small>")}</small>`;
        },
      },
      {
        data: "riverAreaName",
        name: "riverAreaName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "watershedName",
        name: "watershedName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      {
        data: "rainfallLastHour",
        name: "rainfallLastHour",
        className: "text-center text-nowrap",
        createdCell: function (td, cellData, rowData, row, col) {
          switch (rowData.intensityLastHour) {
            case 0:
              $(td).addClass("bg-berawan");
              break;

            case 1:
              $(td).addClass("bg-hujan-ringan");
              break;

            case 2:
              $(td).addClass("bg-hujan-sedang");
              break;

            case 3:
              $(td).addClass("bg-hujan-lebat");
              break;
            case 4:
              $(td).addClass("bg-hujan-sangat-lebat");
              break;
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "intensityLastHour",
        name: "intensityLastHour",
        className: "text-center text-nowrap",
        createdCell: function (td, cellData, rowData, row, col) {
          switch (cellData) {
            case 0:
              $(td).addClass("bg-berawan");
              break;

            case 1:
              $(td).addClass("bg-hujan-ringan");
              break;

            case 2:
              $(td).addClass("bg-hujan-sedang");
              break;

            case 3:
              $(td).addClass("bg-hujan-lebat");
              break;
            case 4:
              $(td).addClass("bg-hujan-sangat-lebat");
              break;
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<small class="fst-italic text-dark">${getIntensityName(
            data
          )}</small>`;
        },
      },
      {
        data: "rainfallDay",
        name: "rainfallDay",
        className: "text-center text-nowrap",
        createdCell: function (td, cellData, rowData, row, col) {
          switch (rowData.intensityDay) {
            case 0:
              $(td).addClass("bg-berawan");
              break;

            case 1:
              $(td).addClass("bg-hujan-ringan");
              break;

            case 2:
              $(td).addClass("bg-hujan-sedang");
              break;

            case 3:
              $(td).addClass("bg-hujan-lebat");
              break;
            case 4:
              $(td).addClass("bg-hujan-sangat-lebat");
              break;
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "intensityDay",
        name: "intensityDay",
        className: "text-center text-nowrap",
        createdCell: function (td, cellData, rowData, row, col) {
          switch (cellData) {
            case 0:
              $(td).addClass("bg-berawan");
              break;

            case 1:
              $(td).addClass("bg-hujan-ringan");
              break;

            case 2:
              $(td).addClass("bg-hujan-sedang");
              break;

            case 3:
              $(td).addClass("bg-hujan-lebat");
              break;
            case 4:
              $(td).addClass("bg-hujan-sangat-lebat");
              break;
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<small class="fst-italic text-dark">${getIntensityName(
            data
          )}</small>`;
        },
      },
      {
        data: "battery",
        name: "Battery",
        className: "text-center",
        render: function (data, type, row) {
          console.log(data);
          if (data == null) {
            return "-";
          }

          return data;
        },
      },
    ];

    function renderWqmsSensorCell(data, row, flagKey) {
      if (!row[flagKey]) {
        return "-";
      }
      if (data == null) {
        return "-";
      }
      return data;
    }

    function buildWqmsColumns() {
      var visible =
        typeof wqmsVisibleSensors !== "undefined" ? wqmsVisibleSensors : {};
      var cols = [
        { data: null },
        {
          data: "name",
          name: "name",
          render: function (data, type, row) {
            return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
          },
        },
        {
          data: "readingAt",
          name: "readingAt",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data != null) {
              return `${moment
                .parseZone(data)
                .locale("id")
                .format("D MMMM YYYY")}`;
            }

            return "-";
          },
        },
        {
          data: "readingAt",
          name: "readingAt",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data != null) {
              return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
            }

            return "-";
          },
        },
      ];

      var sensorDefs = [
        { flag: "isTemperature", data: "temperature" },
        { flag: "isPh", data: "ph" },
        { flag: "isOrp", data: "orp" },
        { flag: "isTurbidity", data: "turbidity" },
        { flag: "isCod", data: "cod" },
        { flag: "isSalinity", data: "salinity" },
        { flag: "isWaterLevel", data: "waterLevel" },
        { flag: "isDo", data: "do" },
        { flag: "isAmmonium", data: "ammonium" },
        { flag: "isAmmonia", data: "ammonia" },
      ];

      sensorDefs.forEach(function (def) {
        if (visible[def.flag]) {
          cols.push({
            data: def.data,
            name: def.data,
            className: "text-center",
            render: function (data, type, row) {
              return renderWqmsSensorCell(data, row, def.flag);
            },
          });
        }
      });

      if (USE_BATTERY_COLUMN) {
        cols.push({
          data: "battery",
          name: "Battery",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return data;
          },
        });
      }

      return cols;
    }

    var wqmsColumn = buildWqmsColumns();

    var flowMeterColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-nowrap",
        render: function (data, type, row) {
          if (row.deviceStatus == "offline") {
            return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
          }

          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "deviceId",
        name: "deviceId",
        className: "text-center",
        render: function (data, type, row) {
          return `<span class="badge badge-outline-blue rounded-1 ms-1">${data}</span>`;
        },
      },
      {
        data: "regencyName",
        name: "regencyName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          // Mengambil hasil dari fungsi-fungsi yang diinginkan
          const regency = setRegencyName(data);
          const district = setDistrictName(row.districtName);
          const village = setVillageName(row.villageName);

          // Membuat array dari hasil dan menyaring nilai kosong
          const locations = [regency, district, village].filter(Boolean);

          // Menggabungkan hasil dengan koma
          return `<small>${locations.join("</small>, <small>")}</small>`;
        },
      },
      {
        data: "riverAreaName",
        name: "riverAreaName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "watershedName",
        name: "watershedName",
        render: function (data, type, row) {
          if (data == null) {
            return '<p class="text-center m-0">-</p>';
          }

          return setUppercase(data);
        },
      },
      {
        data: "readingHour",
        name: "readingHour",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingHour",
        name: "readingHour",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            let previousHour = moment
              .parseZone(data)
              .subtract(1, "hour")
              .locale("id")
              .format("HH:mm");
            return `${previousHour} - ${moment
              .parseZone(data)
              .locale("id")
              .format("HH:mm")}`;
          }

          return "-";
        },
      },
      {
        data: "pipeOuterDiameter",
        name: "pipeOuterDiameter",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="d-flex justify-content-center align-items-center fw-semibold">${data}</span>`;
        },
      },
      {
        data: "flowHour",
        name: "flowHour",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          console.log(row);
          if (data == null) {
            return "-";
          }

          return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${formatNumber(
            data
          )}</span>`;
        },
      },
      {
        data: "flowMonth",
        name: "flowMonth",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${formatNumber(
            data
          )}</span>`;
        },
      },
      {
        data: "flowTotal",
        name: "flowTotal",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${formatNumber(
            data
          )}</span>`;
        },
      },
      { data: "battery", name: "Battery", className: "text-center" },
      {
        data: "battery",
        name: "Battery",
        className: "text-center",
        render: function (data, type, row) {
          return calculateCapacity(data);
        },
      },
    ];

    var vnotchColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-nowrap",
        render: function (data, type, row) {
          var result = `<div title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true"><i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold">${data}</a></div>`;

          if (row.readingAt != null) {
            var readingAt = moment.parseZone(row.readingAt);
            var currentTime = moment();

            const diffInMinutes = currentTime.diff(readingAt, "minutes");

            if (Math.abs(diffInMinutes) >= 5) {
              result = `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
            }
          }

          return result;
        },
      },
      {
        data: "deviceId",
        name: "deviceId",
        className: "text-center",
        render: function (data, type, row) {
          return `<span class="badge badge-outline-secondary rounded-1 ms-1">${data}</span>`;
        },
      },
      {
        data: "watershedName",
        name: "watershedName",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<small class="text-center">${data}</small>`;
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      {
        data: "waterLevel",
        name: "waterLevel",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data} <small class="text-muted">${row.unitDisplay}</small></span>`;
        },
      },
      {
        data: "changeStatus",
        name: "changeStatus",
        className: "text-center",
        render: function (data, type, row) {
          if (data == "const") {
            return `<small class="text-muted fst-italic">TMA Tetap</small>`;
          } else if (data == "inc") {
            return `<div class="d-flex justify-content-center align-items-center">
                                <i class="mdi mdi-arrow-up-circle text-danger font-16 me-1"></i>
                                <small class="text-danger">${row.changeValue} ${row.unitDisplay}</small>
                            </div>`;
          } else if (data == "dec") {
            return `<div class="d-flex justify-content-center align-items-center">
                                <i class="mdi mdi-arrow-down-circle text-success font-16 me-1"></i>
                                <small class="text-success">${row.changeValue} ${row.unitDisplay}</small>
                            </div>`;
          }

          return "-";
        },
      },
      {
        data: "debit",
        name: "debit",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data} <small class="text-muted">${row.debitUnit}</small></span>`;
        },
      },
      {
        data: "battery",
        name: "battery",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return data;
        },
      },
    ];

    var piezometerColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        render: function (data, type, row) {
          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      {
        data: "waterLevel",
        name: "waterLevel",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data} ${row.unitDisplay}</span>`;
        },
      },
      {
        data: "changeStatus",
        name: "changeStatus",
        className: "text-center",
        render: function (data, type, row) {
          if (data == "constant") {
            return ``;
          } else if (data == "increase") {
            return `<div class="d-flex justify-content-center align-items-center">
                                <i class="mdi mdi-arrow-up-circle text-danger font-16 me-1"></i>
                                <small class="text-danger">${row.changeValue}</small>
                            </div>`;
          } else if (data == "decrease") {
            return `<div class="d-flex justify-content-center align-items-center">
                                <i class="mdi mdi-arrow-down-circle text-success font-16 me-1"></i>
                                <small class="text-success">${row.changeValue}</small>
                            </div>`;
          }

          return "";
        },
      },
      { data: "battery", name: "battery", className: "text-center" },
    ];

    var vibratingWireColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-start text-nowrap",
        render: function (data, type, row) {
          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "point",
        name: "point",
        className: "text-center text-nowrap fw-bold",
      },
      {
        data: "deviceId",
        name: "deviceId",
        className: "text-center",
        render: function (data, type, row) {
          return `<span class="badge badge-outline-secondary rounded-1 ms-1">${data}</span>`;
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      { 
        data: "frequency",
        className: "text-center ",
        render: function (data, type, row) {
          if (!row.isActive) return "-";
          return data;
        }
      },
      { data: "temperature", className: "text-center text-nowrap" },
      { data: "ekpa", className: "text-center text-nowrap" },
      { data: "mh20", className: "text-center text-nowrap" },
      { data: "elevation", className: "text-center text-nowrap" },
      {
        data: "battery",
        className: "text-center ",
        render: function (data) {
          if (data == null) return "";
          return data.toFixed(2);
        },
      },
    ];

    var vibratingWireColumnOrgO59 = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-start text-nowrap",
        render: function (data, type, row) {
          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "point",
        name: "point",
        className: "text-center text-nowrap fw-bold",
      },
      {
        data: "deviceId",
        name: "deviceId",
        className: "text-center",
        render: function (data, type, row) {
          return `<span class="badge badge-outline-secondary rounded-1 ms-1">${data}</span>`;
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      { data: "frequency", className: "text-center " },

      { data: "ekpa", className: "text-center text-nowrap" },
      { data: "mh20", className: "text-center text-nowrap" },
      { data: "elevation", className: "text-center text-nowrap" },
      {
        data: "battery",
        className: "text-center ",
        render: function (data) {
          if (data == null) return "";
          return data.toFixed(2);
        },
      },
    ];

    // ============== END VARIABLE COLUMNS DATATABLE ================= //

    if (!USE_BATTERY_COLUMN) {
      awlrColumn = awlrColumn.filter(function (item) {
        return item.name !== nameYangDihapus;
      });

      awlrTmatColumn = awlrTmatColumn.filter(function (item) {
        return item.name !== nameYangDihapus;
      });

      awlrArrColumn = awlrArrColumn.filter(function (item) {
        return item.name !== nameYangDihapus;
      });

      arrColumn = arrColumn.filter(function (item) {
        return item.name !== nameYangDihapus;
      });

      flowMeterColumn = flowMeterColumn.filter(function (item) {
        return item.name !== nameYangDihapus;
      });

      vnotchColumn = vnotchColumn.filter(function (item) {
        return item.name !== nameYangDihapus;
      });

      piezometerColumn = piezometerColumn.filter(function (item) {
        return item.name !== nameYangDihapus;
      });

      vibratingWireColumnOrgO59 = vibratingWireColumnOrgO59.filter(function (
        item
      ) {
        return item.name !== nameYangDihapus;
      });

      vibratingWireColumn = vibratingWireColumn.filter(function (item) {
        return item.name !== nameYangDihapus;
      });
    }

    if (totalAwlr > 0 && $("#awlr-table").length) {
      dataTableAwlr = $("#awlr-table").DataTable({
        processing: true,
        serverSide: true,
        paging: false,
        searching: false,
        ordering: false,
        info: false,
        ajax: {
          url: "/Home/GetDatatableAwlrLastReading",
          type: "POST",
          dataType: "JSON",
          error: function (eventError, textStatus, errorThrown) {
            console.log(formatErrorMessage(eventError, errorThrown));
          },
        },
        columns: awlrColumn,
        columnDefs: [
          {
            targets: 0,
            searchable: false,
            orderable: false,
            width: "6%",
            className: "text-center",
          },
        ],
        language: {
          url: "/data/datatable_locale_id.json",
        },
        drawCallback: function (settings) {
          if ($('[data-plugin="tippy"]').length > 0) {
            tippy('[data-plugin="tippy"]');
          }
        },
      });

      dataTableAwlr.on("error.dt", function (e, settings, techNote, message) {
        console.log("An error has been reported by DataTables: ", message);
      });

      dataTableAwlr.on("draw.dt", function () {
        var info = dataTableAwlr.page.info();
        dataTableAwlr
          .column(0, { search: "applied", order: "applied", page: "applied" })
          .nodes()
          .each(function (cell, i) {
            cell.innerHTML = i + 1 + info.start;
          });
      });
    }

    if (typeof totalOw !== "undefined" && totalOw > 0 && $("#ow-table").length) {
      const owColumn = [
        { data: null },
        {
          data: "name",
          name: "name",
          className: "text-nowrap",
          render: function (data, type, row) {
            if (row.deviceStatus == "offline") {
              return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
            }
            return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
          },
        },
        {
          data: "deviceId",
          name: "deviceId",
          className: "text-center",
          render: function (data) {
            return `<span class="badge badge-outline-blue rounded-1 ms-1">${data}</span>`;
          },
        },
        {
          data: "regencyName",
          name: "regencyName",
          render: function (data, type, row) {
            if (data == null) return '<p class="text-center m-0">-</p>';
            const locations = [
              setRegencyName(data),
              setDistrictName(row.districtName),
              setVillageName(row.villageName),
            ].filter(Boolean);
            return `<small>${locations.join("</small>, <small>")}</small>`;
          },
        },
        {
          data: "riverAreaName",
          name: "riverAreaName",
          render: function (data) {
            return data == null ? '<p class="text-center m-0">-</p>' : setUppercase(data);
          },
        },
        {
          data: "watershedName",
          name: "watershedName",
          render: function (data) {
            return data == null ? '<p class="text-center m-0">-</p>' : setUppercase(data);
          },
        },
        {
          data: "readingAt",
          name: "readingAt",
          className: "text-center text-nowrap",
          render: function (data) {
            return data != null
              ? `${moment.parseZone(data).locale("id").format("D MMMM YYYY")}`
              : "-";
          },
        },
        {
          data: "readingAt",
          name: "readingAt",
          className: "text-center text-nowrap",
          render: function (data) {
            return data != null
              ? `${moment.parseZone(data).locale("id").format("HH:mm")}`
              : "-";
          },
        },
        {
          data: "wellDepth",
          name: "wellDepth",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data != null) {
              return `<span class="text-dark fw-semibold">${data} <small class="text-muted">${row.wellDepthUnit || "m"}</small></span>`;
            }
            return "-";
          },
        },
        {
          data: "waterLevel",
          name: "waterLevel",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data == null) return "-";
            return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${data} <small style="margin-left: 3px;">${row.unitDisplay || "m"}</small></span>`;
          },
        },
        {
          data: "waterLevelElevation",
          name: "waterLevelElevation",
          className: "text-center text-nowrap",
          render: function (data) {
            if (data == null) return "-";
            return `<span class="d-flex justify-content-center align-items-center text-dark fw-semibold">${data} <small style="margin-left: 3px;">mdpl</small></span>`;
          },
        },
        { data: "battery", name: "Battery", className: "text-center" },
      ];

      if (!USE_BATTERY_COLUMN) {
        const idx = owColumn.findIndex((c) => c.name === "Battery");
        if (idx >= 0) owColumn.splice(idx, 1);
      }

      dataTableOw = $("#ow-table").DataTable({
        processing: true,
        serverSide: true,
        paging: false,
        searching: false,
        ordering: false,
        info: false,
        ajax: {
          url: "/Home/GetDatatableOwLastReading",
          type: "POST",
          dataType: "JSON",
          error: function (eventError, textStatus, errorThrown) {
            console.log(formatErrorMessage(eventError, errorThrown));
          },
        },
        columns: owColumn,
        columnDefs: [
          {
            targets: 0,
            searchable: false,
            orderable: false,
            width: "6%",
            className: "text-center",
          },
        ],
        language: { url: "/data/datatable_locale_id.json" },
        drawCallback: function () {
          if ($('[data-plugin="tippy"]').length > 0) {
            tippy('[data-plugin="tippy"]');
          }
        },
      });

      dataTableOw.on("draw.dt", function () {
        var info = dataTableOw.page.info();
        dataTableOw
          .column(0, { search: "applied", order: "applied", page: "applied" })
          .nodes()
          .each(function (cell, i) {
            cell.innerHTML = i + 1 + info.start;
          });
      });
    }

    if (totalAgwlr > 0 && $("#awlr-tmat-table").length) {
      dataTableAwlrTmat = $("#awlr-tmat-table").DataTable({
        processing: true,
        serverSide: true,
        paging: false,
        searching: false,
        ordering: false,
        info: false,
        ajax: {
          url: "/Home/GetDatatableAwlrTmatLastReading",
          type: "POST",
          dataType: "JSON",
          error: function (eventError, textStatus, errorThrown) {
            console.log(formatErrorMessage(eventError, errorThrown));
          },
        },
        columns: awlrTmatColumn,
        columnDefs: [
          {
            targets: 0,
            searchable: false,
            orderable: false,
            width: "6%",
            className: "text-center",
          },
        ],
        language: {
          url: "/data/datatable_locale_id.json",
        },
        drawCallback: function (settings) {
          if ($('[data-plugin="tippy"]').length > 0) {
            tippy('[data-plugin="tippy"]');
          }
        },
      });

      dataTableAwlrTmat.on(
        "error.dt",
        function (e, settings, techNote, message) {
          console.log("An error has been reported by DataTables: ", message);
        },
      );

      dataTableAwlrTmat.on("draw.dt", function () {
        var info = dataTableAwlrTmat.page.info();
        dataTableAwlrTmat
          .column(0, { search: "applied", order: "applied", page: "applied" })
          .nodes()
          .each(function (cell, i) {
            cell.innerHTML = i + 1 + info.start;
          });
      });
    }

    // AWLR & ARR

    dataTableAwlrArr = $("#awlr-arr-table").DataTable({
      processing: true,
      serverSide: true,
      paging: false,
      searching: false,
      ordering: false,
      info: false,
      ajax: {
        url: "/Home/GetDatatableAwlrArrLastReading",
        type: "POST",
        dataType: "JSON",
        error: function (eventError, textStatus, errorThrown) {
          console.log(formatErrorMessage(eventError, errorThrown));
        },
      },
      columns: awlrArrColumn,
      columnDefs: [
        {
          targets: 0,
          searchable: false,
          orderable: false,
          width: "6%",
          className: "text-center",
        },
      ],
      language: {
        url: "/data/datatable_locale_id.json",
      },
      drawCallback: function (settings) {
        if ($('[data-plugin="tippy"]').length > 0) {
          tippy('[data-plugin="tippy"]');
        }
      },
    });

    dataTableAwlrArr.on("error.dt", function (e, settings, techNote, message) {
      console.log("An error has been reported by DataTables: ", message);
    });

    dataTableAwlrArr.on("draw.dt", function () {
      var info = dataTableAwlrArr.page.info();
      dataTableAwlrArr
        .column(0, { search: "applied", order: "applied", page: "applied" })
        .nodes()
        .each(function (cell, i) {
          cell.innerHTML = i + 1 + info.start;
        });
    });

    //TABLE ARR
    dataTableArr = $("#arr-table").DataTable({
      processing: true,
      serverSide: true,
      paging: false,
      searching: false,
      ordering: false,
      info: false,
      scrollX: false,
      ajax: {
        url: "/Home/GetDatatableArrLastReading",
        type: "POST",
        dataType: "JSON",
      },
      columns: arrColumn,
      columnDefs: [
        {
          targets: 0,
          searchable: false,
          orderable: false,
          width: "6%",
          className: "text-center",
        },
      ],
      language: {
        url: "/data/datatable_locale_id.json",
      },
      drawCallback: function (settings) {
        if ($('[data-plugin="tippy"]').length > 0) {
          tippy('[data-plugin="tippy"]');
        }
      },
    });

    dataTableArr.on("draw.dt", function () {
      var info = dataTableArr.page.info();
      dataTableArr
        .column(0, { search: "applied", order: "applied", page: "applied" })
        .nodes()
        .each(function (cell, i) {
          cell.innerHTML = i + 1 + info.start;
        });
    });

    // TABLE WQMS
    if ($("#wqms-table").length) {
      wqmsColumn = buildWqmsColumns();

      dataTableWqms = $("#wqms-table").DataTable({
        processing: true,
        serverSide: true,
        paging: false,
        searching: false,
        ordering: false,
        info: false,
        scrollX: false,
        ajax: {
          url: "/Home/GetDatatableWqmsLastReading",
          type: "POST",
          dataType: "JSON",
        },
        columns: wqmsColumn,
        columnDefs: [
          {
            targets: 0,
            searchable: false,
            orderable: false,
            width: "6%",
            className: "text-center",
          },
        ],
        language: {
          url: "/data/datatable_locale_id.json",
        },
      });

      dataTableWqms.on("draw.dt", function () {
        var info = dataTableWqms.page.info();
        dataTableWqms
          .column(0, { search: "applied", order: "applied", page: "applied" })
          .nodes()
          .each(function (cell, i) {
            cell.innerHTML = i + 1 + info.start;
          });
      });
    }

    //TABLE FLOMETER

    dataTableFlowMeter = $("#fm-table").DataTable({
      processing: true,
      serverSide: true,
      paging: false,
      searching: false,
      ordering: false,
      info: false,
      ajax: {
        url: "/Home/GetDatatableFlowMeterLastReading",
        type: "POST",
        dataType: "JSON",
        error: function (eventError, textStatus, errorThrown) {
          console.log(formatErrorMessage(eventError, errorThrown));
        },
      },
      columns: flowMeterColumn,
      columnDefs: [
        {
          targets: 0,
          searchable: false,
          orderable: false,
          width: "6%",
          className: "text-center",
        },
      ],
      language: {
        url: "/data/datatable_locale_id.json",
      },
      drawCallback: function (settings) {
        if ($('[data-plugin="tippy"]').length > 0) {
          tippy('[data-plugin="tippy"]');
        }
      },
    });

    dataTableFlowMeter.on(
      "error.dt",
      function (e, settings, techNote, message) {
        console.log("An error has been reported by DataTables: ", message);
      }
    );

    dataTableFlowMeter.on("draw.dt", function () {
      var info = dataTableFlowMeter.page.info();
      dataTableFlowMeter
        .column(0, { search: "applied", order: "applied", page: "applied" })
        .nodes()
        .each(function (cell, i) {
          cell.innerHTML = i + 1 + info.start;
        });
    });

    var awsColumn = [
      { data: null },
      {
        data: "name",
        name: "name",
        className: "text-nowrap",
        render: function (data, type, row) {
          if (row.deviceStatus == "offline") {
            return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/Station/Detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
          }

          return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment
              .parseZone(data)
              .locale("id")
              .format("D MMMM YYYY")}`;
          }

          return "-";
        },
      },
      {
        data: "readingAt",
        name: "readingAt",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data != null) {
            return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
          }

          return "-";
        },
      },
      {
        data: "humidity",
        name: "humidity",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}%</span><br/><small class="text-muted">${row.humidityStatus}</small>`;
        },
      },
      {
        data: "rainfall",
        name: "rainfall",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data} <small>mm</small></span>`;
        },
      },
      {
        data: "intensityLastHour",
        name: "intensityLastHour",
        className: "text-center text-nowrap",
        createdCell: function (td, cellData, rowData, row, col) {
          switch (cellData) {
            case 0:
              $(td).addClass("bg-berawan");
              break;

            case 1:
              $(td).addClass("bg-hujan-ringan");
              break;

            case 2:
              $(td).addClass("bg-hujan-sedang");
              break;

            case 3:
              $(td).addClass("bg-hujan-lebat");
              break;
            case 4:
              $(td).addClass("bg-hujan-sangat-lebat");
              break;
          }
        },
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${
            row.rainfallLastHour
          } <small>mm</small></span><br/><small class="text-dark">${getIntensityName(
            data
          )}</small>`;
        },
      },
      {
        data: "pressure",
        name: "pressure",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "solarRadiation",
        name: "solarRadiation",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "sunshineHour",
        name: "sunshineHour",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "temperature",
        name: "temperature",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "windDirection",
        name: "windDirection",
        className: "text-center text-nowrap",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}&deg;</span><br/>
                    <small class="d-flex justify-content-center align-items-center text-muted">
                        <span style="transform: rotate(${data}deg);"><i class="mdi mdi-navigation"></i></span>
                        <span class="ms-1">${row.windDirectionStatus}</span>
                    </small>`;
        },
      },
      {
        data: "windSpeed",
        name: "windSpeed",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "evaporation",
        name: "evaporation",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "uv",
        name: "uv",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
      {
        data: "battery",
        name: "battery",
        className: "text-center",
        render: function (data, type, row) {
          if (data == null) {
            return "-";
          }

          return `<span class="text-dark fw-semibold">${data}</span>`;
        },
      },
    ];

    if (organizationCode == "ORG019") {
      awsColumn = [
        { data: null },
        {
          data: "name",
          name: "name",
          className: "text-nowrap",
          render: function (data, type, row) {
            if (row.deviceStatus == "offline") {
              return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/station/detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
            }

            return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
          },
        },
        {
          data: "deviceId",
          name: "deviceId",
          className: "text-center",
          render: function (data, type, row) {
            return `<span class="badge badge-outline-blue rounded-1 ms-1">${data}</span>`;
          },
        },
        {
          data: "regencyName",
          name: "regencyName",
          render: function (data, type, row) {
            if (data == null) {
              return '<p class="text-center m-0">-</p>';
            }

            // Mengambil hasil dari fungsi-fungsi yang diinginkan
            const regency = setRegencyName(data);
            const district = setDistrictName(row.districtName);
            const village = setVillageName(row.villageName);

            // Membuat array dari hasil dan menyaring nilai kosong
            const locations = [regency, district, village].filter(Boolean);

            // Menggabungkan hasil dengan koma
            return `<small>${locations.join("</small>, <small>")}</small>`;
          },
        },
        {
          data: "riverAreaName",
          name: "riverAreaName",
          render: function (data, type, row) {
            if (data == null) {
              return '<p class="text-center m-0">-</p>';
            }

            return setUppercase(data);
          },
        },
        {
          data: "watershedName",
          name: "watershedName",
          render: function (data, type, row) {
            if (data == null) {
              return '<p class="text-center m-0">-</p>';
            }

            return setUppercase(data);
          },
        },
        {
          data: "readingAt",
          name: "readingAt",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data != null) {
              return `${moment
                .parseZone(data)
                .locale("id")
                .format("D MMMM YYYY")}`;
            }

            return "-";
          },
        },
        {
          data: "readingAt",
          name: "readingAt",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data != null) {
              return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
            }

            return "-";
          },
        },
        {
          data: "humidity",
          name: "humidity",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data}%</span><br/><small class="text-muted">${row.humidityStatus}</small>`;
          },
        },
        {
          data: "rainfall",
          name: "rainfall",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data} <small>mm</small></span>`;
          },
        },
        {
          data: "intensityLastHour",
          name: "intensityLastHour",
          className: "text-center text-nowrap",
          createdCell: function (td, cellData, rowData, row, col) {
            switch (cellData) {
              case 0:
                $(td).addClass("bg-berawan");
                break;

              case 1:
                $(td).addClass("bg-hujan-ringan");
                break;

              case 2:
                $(td).addClass("bg-hujan-sedang");
                break;

              case 3:
                $(td).addClass("bg-hujan-lebat");
                break;
              case 4:
                $(td).addClass("bg-hujan-sangat-lebat");
                break;
            }
          },
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${
              row.rainfallLastHour
            } <small>mm</small></span><br/><small class="text-dark">${getIntensityName(
              data
            )}</small>`;
          },
        },
        {
          data: "pressure",
          name: "pressure",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data}</span>`;
          },
        },
        {
          data: "solarRadiation",
          name: "solarRadiation",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data}</span>`;
          },
        },
        {
          data: "sunshineHour",
          name: "sunshineHour",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data}</span>`;
          },
        },
        {
          data: "temperature",
          name: "temperature",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data}</span>`;
          },
        },
        {
          data: "windDirection",
          name: "windDirection",
          className: "text-center text-nowrap",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data}&deg;</span><br/>
                        <small class="d-flex justify-content-center align-items-center text-muted">
                            <span style="transform: rotate(${data}deg);"><i class="mdi mdi-navigation"></i></span>
                            <span class="ms-1">${row.windDirectionStatus}</span>
                        </small>`;
          },
        },
        {
          data: "windSpeed",
          name: "windSpeed",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data}</span>`;
          },
        },
        {
          data: "evaporation",
          name: "evaporation",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data}</span>`;
          },
        },
        {
          data: "battery",
          name: "battery",
          className: "text-center",
          render: function (data, type, row) {
            if (data == null) {
              return "-";
            }

            return `<span class="text-dark fw-semibold">${data}</span>`;
          },
        },
      ];
    }

    // TABLE AWS
    loadAwsTable();

    // TABLE V-NOTCH

    dataTableVnotch = $("#vnotch-table").DataTable({
      processing: true,
      serverSide: true,
      paging: false,
      searching: false,
      ordering: false,
      info: false,
      ajax: {
        url: "/Home/GetDatatableVnotchLastReading",
        type: "POST",
        dataType: "JSON",
      },
      columns: vnotchColumn,
      columnDefs: [
        {
          targets: 0,
          searchable: false,
          orderable: false,
          width: "6%",
          className: "text-center",
        },
      ],
      language: {
        url: "/data/datatable_locale_id.json",
      },
    });

    dataTableVnotch.on("draw.dt", function () {
      var info = dataTableVnotch.page.info();
      dataTableVnotch
        .column(0, { search: "applied", order: "applied", page: "applied" })
        .nodes()
        .each(function (cell, i) {
          cell.innerHTML = i + 1 + info.start;
        });
    });

    //TABLE PIEZOMETER

    dataTablePiezometer = $("#piezometer-table").DataTable({
      processing: true,
      serverSide: true,
      paging: false,
      searching: false,
      ordering: false,
      info: false,
      ajax: {
        url: "/Home/GetDatatablePiezometerLastReading",
        type: "POST",
        dataType: "JSON",
      },
      columns: piezometerColumn,
      columnDefs: [
        {
          targets: 0,
          searchable: false,
          orderable: false,
          width: "6%",
          className: "text-center",
        },
      ],
      language: {
        url: "/data/datatable_locale_id.json",
      },
    });

    dataTablePiezometer.on("draw.dt", function () {
      var info = dataTablePiezometer.page.info();
      dataTablePiezometer
        .column(0, { search: "applied", order: "applied", page: "applied" })
        .nodes()
        .each(function (cell, i) {
          cell.innerHTML = i + 1 + info.start;
        });
    });

    /* VIBRATING WIRE */

    dataTableVibratingWire = $("#vibrating-wire-table").DataTable({
      processing: true,
      serverSide: true,
      paging: false,
      searching: false,
      ordering: false,
      info: false,
      ajax: {
        url: "/Home/GetDatatableAvwrLastReading",
        type: "POST",
        dataType: "JSON",
      },
      columns:
        OrgCode == "ORG059" ? vibratingWireColumnOrgO59 : vibratingWireColumn,
      columnDefs: [
        {
          targets: 0,
          searchable: false,
          orderable: false,
          width: "6%",
          className: "text-center",
        },
      ],
      language: {
        url: "/data/datatable_locale_id.json",
      },
    });

    dataTableVibratingWire.on("draw.dt", function () {
      var info = dataTableVibratingWire.page.info();
      dataTableVibratingWire
        .column(0, { search: "applied", order: "applied", page: "applied" })
        .nodes()
        .each(function (cell, i) {
          cell.innerHTML = i + 1 + info.start;
        });
    });
  };

  return {
    //main function to initiate the module
    init: function () {
      window.addEventListener("load", () => {
        initMap().catch((err) => console.error("Map init failed:", err));
        loadLastReading();
      });
      initDataTable();
      setInterval(loadLastReading, 300000);
    },
  };
})();

jQuery(document).ready(function () {
  TabelMonitoring.init();
  loadCctv().catch((err) => console.error("CCTV load failed:", err));
  startCctvAutoRefresh();
});

async function loadLastReading() {
  if (dataTableAwlr) {
    dataTableAwlr.ajax.reload();
  }
  if (dataTableAwlrTmat) {
    dataTableAwlrTmat.ajax.reload();
  }
  if (dataTableOw) {
    dataTableOw.ajax.reload();
  }
  if (dataTableArr) {
    dataTableArr.ajax.reload();
  }
  if (dataTableAwlrArr) {
    dataTableAwlrArr.ajax.reload();
  }
  if (dataTableAws) {
    dataTableAws.ajax.reload();
  }
}

function getIntensityName(status) {
  let result = "-";

  switch (parseInt(status)) {
    case 0:
      result = "Tidak Hujan";
      break;
    case 1:
      result = "Hujan Ringan";
      break;
    case 2:
      result = "Hujan Sedang";
      break;
    case 3:
      result = "Hujan Lebat";
      break;
    case 4:
      result = "Hujan Sangat Lebat";
      break;
  }

  return result;
}

function getIntensityIcon(status) {
  let timeOfDay = "pagi";

  let momentjs = moment();
  momentjs.locale("id");

  momentjs.tz("Asia/Jakarta");

  let currentHour = momentjs.hours();

  if (currentHour >= 5 && currentHour < 10) {
    timeOfDay = "pagi";
  } else if (currentHour >= 10 && currentHour < 17) {
    timeOfDay = "siang";
  } else if (currentHour >= 17 && currentHour < 19) {
    timeOfDay = "sore";
  } else {
    timeOfDay = "malam";
  }

  let icon = "-";

  switch (parseInt(status)) {
    case 0:
      icon = '<small class="text-body fst-italic">Tidak Ada Hujan</small>';
      break;
    case 1:
      icon =
        '<img src="/images/arr/hujan-ringan.png" alt="Hujan Ringan" class="avatar-xs me-1"><small class="text-body fst-italic">Hujan Ringan</small>';
      break;
    case 2:
      icon =
        '<img src="/images/arr/hujan-sedang.png" alt="Hujan Sedang" class="avatar-xs me-1"><small class="text-body fst-italic">Hujan Sedang</small>';
      break;
    case 3:
      icon =
        '<img src="/images/arr/hujan-lebat.png" alt="Hujan Lebat" class="avatar-xs me-1"><small class="text-body fst-italic">Hujan Lebat</small>';
      break;
    case 4:
      icon =
        '<img src="/images/arr/hujan-sangat-lebat.png" alt="Hujan Sangat Lebat" class="avatar-xs me-1"><small class="text-body fst-italic">Hujan Sangat Lebat</small>';
      break;
  }

  return icon;
}

function getIntensityIconMap(status) {
  let timeOfDay = "pagi";

  let momentjs = moment();
  momentjs.locale("id");

  momentjs.tz("Asia/Jakarta");

  let currentHour = momentjs.hours();

  if (currentHour >= 5 && currentHour < 10) {
    timeOfDay = "pagi";
  } else if (currentHour >= 10 && currentHour < 17) {
    timeOfDay = "siang";
  } else if (currentHour >= 17 && currentHour < 19) {
    timeOfDay = "sore";
  } else {
    timeOfDay = "malam";
  }

  let icon = "-";

  switch (status) {
    case 0:
      icon =
        '<img src="/images/arr/berawan.png" alt="Tidak Ada Hujan" class="avatar-xs">';
      break;
    case 1:
      icon =
        '<img src="/images/arr/hujan-ringan.png" alt="Hujan Ringan" class="avatar-xs">';
      break;
    case 2:
      icon =
        '<img src="/images/arr/hujan-sedang.png" alt="Hujan Sedang" class="avatar-xs">';
      break;
    case 3:
      icon =
        '<img src="/images/arr/hujan-lebat.png" alt="Hujan Lebat" class="avatar-xs">';
      break;
    case 4:
      icon =
        '<img src="/images/arr/hujan-sangat-lebat.png" alt="Hujan Sangat Lebat" class="avatar-xs">';
      break;
  }

  return icon;
}

function createDetailPanelStation(reading) {
  var photo = "/images/default-pu.png";

  if (reading.photo != null) {
    var photo = `/uploads/images/stations/${reading.photo}`;
  }
  var device_status =
    '<small class="mdi mdi-circle text-danger"></small> Offline';

  if (reading.deviceStatus == "online") {
    device_status =
      '<small class="mdi mdi-circle text-success"></small> Online';
  }

  var panelContent = '<table class="table mb-2 font-12"><tbody>';

  panelContent += "<tr>";
  panelContent += `<td class="px-0 py-2 pt-1" colspan="3">
        <div class="d-flex align-items-start">
            <img class="me-2 rounded-3" src="${photo}" width="35" height="35" alt="${reading.name}">
            <div class="w-100">
                <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${reading.name}</h5>
                ${device_status}
            </div>
        </div>
    </td>`;
  panelContent += "</tr>";

  panelContent += "<tr>";
  panelContent += `<td class="py-1 px-0">Logger</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0 align-middle">
        ${reading.brandName} <span class="badge badge-outline-secondary rounded-1">${reading.deviceId}</span>
    </td>`;
  panelContent += "</tr>";

  panelContent += "<tr>";
  panelContent += `<td class="py-1 px-0">Koordinat</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0 align-middle">
        <a href="https://www.google.com/maps?q=${reading.latitude},${reading.longitude}" target="_blank">${reading.latitude}, ${reading.longitude}</a>
    </td>`;
  panelContent += "</tr>";

  if (reading.readingAt != null) {
    panelContent += "<tr>";
    panelContent += `<td class="py-1 px-0">Waktu</td>`;
    panelContent += `<td class="py-1 px-2">:</td>`;
    panelContent += `<td class="py-1 px-0">${moment(reading.readingAt)
      .locale("id")
      .format("D MMMM YYYY HH:mm")} WIB</td>`;
    panelContent += "</tr>";

    if (reading.type == "AWLR") {
      var water_level_elevation =
        reading.waterLevelElevation == null
          ? "-"
          : `${reading.waterLevelElevation.toFixed(2)} <sup>Mdpl</sup>`;
      var debit =
        reading.debit == null ? "-" : `${reading.debit} <sup>m3/s</sup>`;

      var text_tma = `${reading.waterLevel.toFixed(2)} <sup>${
        reading.unitDisplay
      }`;

      if (reading.unitSensor == "cmdpl" || reading.unitSensor == "mdpl") {
        var text_tma = "-";
      }

      panelContent += "<tr>";
      panelContent += `<td class="py-1 px-0 nowrap">Tinggi Muka Air</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${text_tma}</td>`;
      panelContent += "</tr>";

      panelContent += "<tr>";
      panelContent += `<td class="py-1 px-0 nowrap">Elevasi Muka Air</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${water_level_elevation}</td>`;
      panelContent += "</tr>";

      panelContent += "<tr>";
      panelContent += `<td class="py-1 px-0 nowrap">Debit</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${debit}</td>`;
      panelContent += "</tr>";
    } else if (reading.type == "ARR") {
      panelContent += "<tr>";
      panelContent += `<td class="py-1 px-0 nowrap">Curah Hujan</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${reading.rainfall.toFixed(
        2
      )} <sup>mm</sup></td>`;
      panelContent += "</tr>";

      panelContent += "<tr>";
      panelContent += `<td class="py-1 px-0 nowrap">Curah Hujan Maks.</td>`;
      panelContent += `<td class="py-1 px-2">:</td>`;
      panelContent += `<td class="py-1 px-0 fw-semibold">${reading.rainfallMax.toFixed(
        2
      )} <sup>mm</sup></td>`;
      panelContent += "</tr>";
    }
  }

  panelContent += "</tbody></table>";

  panelContent += `<a href="/Station/Detail/${reading.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>`;

  return panelContent;
}

function detailCctv(cctv) {
  let currTimestamp = new Date().getTime();
  var panelContent = '<table class="table mb-2 font-12"><tbody>';

  panelContent += `<a class="image-popup-cctv-marker" href="${cctv.Url}?v=${currTimestamp}" title="${cctv.Name}"><img class="img-fluid rounded-3" src="${cctv.Url}?v=${currTimestamp}" alt="${cctv.Name}"></img></a>`;

  panelContent += "<tr>";
  panelContent += `<td class="py-1 px-0">Nama Lokasi</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0 align-middle">
        ${cctv.Name}
    </td>`;
  panelContent += "</tr>";

  panelContent += "<tr>";
  panelContent += `<td class="py-1 px-0">Latitude</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0 align-middle">
        ${cctv.Latitude}
    </td>`;
  panelContent += "</tr>";

  panelContent += "<tr>";
  panelContent += `<td class="py-1 px-0">Longitude</td>`;
  panelContent += `<td class="py-1 px-2">:</td>`;
  panelContent += `<td class="py-1 px-0 align-middle">
        ${cctv.Longitude}
    </td>`;
  panelContent += "</tr>";

  panelContent += "</tbody></table>";

  return panelContent;
}

function setUppercase(name) {
  if (!name) return null; // Kembalikan null jika name kosong

  const result = name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  return result;
}

function setRegencyName(name) {
  if (!name) return null; // Kembalikan null jika name kosong

  name = name.replace(/\bkabupaten\b/i, "Kab.");

  const result = name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  return result;
}

function setDistrictName(name) {
  if (!name) return null; // Kembalikan null jika name kosong

  name = name.replace(/\bkecamatan\b/i, "Kec.");

  if (!name.toLowerCase().startsWith("kec.")) {
    name = "Kec. " + name;
  }

  const result = name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  return result;
}

function setVillageName(name) {
  // Pastikan name tidak null atau undefined
  if (!name) return null; // Kembalikan null jika name kosong

  // Ganti kata 'kelurahan' dengan 'Kel.'
  name = name.replace(/\bkelurahan\b/i, "Kel.");

  // Format setiap kata dengan huruf pertama kapital
  const result = name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  return result;
}

function loadLegend(map) {
  $.ajax({
    url: "/station/type/total", // URL API
    method: "GET", // HTTP Method
    success: function (response) {
      var legendDiv = document.createElement("div");
      let parentDiv = ` <div class="p-2" style="background-color: white;box-shadow: 0 0 15px rgba(0, 0, 0, 0.3); border-radius: 5px">`;

      response.forEach((lgn) => {
        const legendEntry = StationMarkerConfig.buildLegendEntry(lgn.type);
        if (legendEntry) {
          parentDiv += `<div class="d-flex align-items-center mb-1 justify-content-between ">
                        <div class="${legendEntry.classMarker}" style="width: 18px;height: 18px;box-shadow:none;"></div>
                        <div class="me-1" style="font-weight: bold;">${legendEntry.name}</div>
                        <input  name="tipe-sensor" value="${legendEntry.filterValue}" type="checkbox" checked onchange="changeMarker(this)" />
                    </div>`;
        }
      });

      parentDiv += StationMarkerConfig.buildLegendFootnoteHtml();
      parentDiv += `</div>`;

      legendDiv.innerHTML = parentDiv;
      map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legendDiv);
    },
    error: function (xhr, status, error) {
      console.info(error);
    },
  });
}

/* Bagian hide/show marker */

let markers = [],
  markerData = [];
// let infoWindow = new google.maps.InfoWindow();
// Fungsi untuk mengambil data dari API
async function fetchMarkers() {
  try {
    const response = await fetch("/Home/Markers");
    const data = await response.json();
    markerData = data;
    addMarkers(markerData);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

// Fungsi untuk menambahkan marker ke peta
async function addMarkers(data) {
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  data.forEach((el) => {
    if (!StationMarkerConfig.shouldShowMarkerFromData(el)) return;

    const customMarker = document.createElement("div");
    customMarker.className = StationMarkerConfig.getMarkerClassFromData(el);

    if (el.latitude != null && el.longitude != null) {
      const marker = new AdvancedMarkerElement({
        map,
        position: {
          lat: parseFloat(el.latitude),
          lng: parseFloat(el.longitude),
        },
        content: customMarker,
      });

      markers.push(marker);

      // Menambahkan event listener untuk marker
      google.maps.event.addListener(marker, "click", function () {
        map.setCenter(marker.position);
        map.setZoom(Math.min(map.getZoom() + 2, 20));
        showInfoWindow(el, marker);
      });
    }
  });
}

function getCheckedSensors() {
  // Ambil semua elemen checkbox dengan name="tipe-sensor"
  const checkboxes = document.querySelectorAll(
    'input[name="tipe-sensor"]:checked'
  );
  // Map hasilnya menjadi array yang berisi nilai 'value' dari checkbox yang tercentang
  const checkedValues = Array.from(checkboxes).map(
    (checkbox) => checkbox.value
  );
  // Kembalikan array nilai yang tercentang
  return checkedValues;
}

function changeMarker(input) {
  const value = $(input).val();
  let checked = true;
  if (input.checked) {
    checked = true;
  } else {
    checked = false;
  }
  filterMarkers(value, checked);
}

// Fungsi untuk memfilter marker berdasarkan kategori
function filterMarkers(category, status) {
  // Hapus semua marker dari peta
  console.log(category + " " + status);
  clearMarkers();
  let filterData = markerData;
  let sensors = getCheckedSensors();
  sensors = StationMarkerConfig.normalizeFilterTypes(sensors);
  filterData = filterData.filter((dt) => {
    const markerType = StationMarkerConfig.resolveDataType(dt.type);
    return sensors.includes(markerType) || sensors.includes(dt.type);
  });
  // Tambahkan marker yang terfilter ke peta
  console.log(markerData);
  addMarkers(filterData);
}

// Fungsi untuk menghapus marker dari peta
function clearMarkers() {
  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }
  markers = []; // Reset array marker
}

// Fungsi untuk menampilkan InfoWindow saat marker diklik
function showInfoWindow(data, marker) {
  if (infowindow) {
    infowindow.close();
  }
  let contentPopup = generatePopup(data);
  // Buka infowindow baru
  infowindow = new google.maps.InfoWindow({
    content: contentPopup,
    disableAutoPan: true,
  });
  infowindow.open({
    anchor: marker,
    map,
  });
}

function generatePopup(data) {
  switch (data.type) {
    case "AWLR":
      return contentPopupAwlr(data);
    case "AGWLR":
      return contentPopupAgwlr(data);
    case "OW":
      return contentPopupOw(data);
    case "ARR":
      return contentPopupArr(data);
    case "AWLR_ARR":
      return contentPopupAwlrArr(data);
    case "AWS":
      return contentPopupAws(data);
    case "VNOTCH":
      return contentPopupVNotch(data);
    case "FM":
      return contentPopupFlowMeter(data);
    default:
      return "";
  }
}

function contentPopupOw(data) {
  moment.locale("id");
  const lastData = (data.lastData || "").split("|");
  let watershedName =
    data.watershedName == "" || data.watershedName == null
      ? "-"
      : data.watershedName;
  let reading_at = "-";
  if (data.lastReading != null) {
    reading_at = `${moment
      .parseZone(data.lastReading)
      .format("D MMMM YYYY HH:mm")} ${timeZone}`;
  }
  const water_level =
    lastData[0] != "" && lastData[0] != null
      ? `${lastData[0]} <sup>${data.unit || "m"}</sup>`
      : "-";
  const elevation =
    lastData[1] != "" && lastData[1] != null && lastData[1] != "null"
      ? `${lastData[1]} <sup>mdpl</sup>`
      : "-";
  const status_online = `<span><small class="mdi mdi-circle ${
    data.deviceStatus == "online" ? "text-success" : "text-danger"
  }"></small> ${data.deviceStatus}</span>`;

  return `
    <div class="card mb-0" style="width: 280px;">
      <div class="card-header bg-primary py-2">
        <h5 class="card-title text-white mb-0">${data.name || "-"}</h5>
      </div>
      <div class="card-body p-2">
        <table class="table table-sm table-borderless mb-0">
          <tr><td>Device ID</td><td>: ${data.deviceId || "-"}</td></tr>
          <tr><td>DAS</td><td>: ${watershedName}</td></tr>
          <tr><td>Status</td><td>: ${status_online}</td></tr>
          <tr><td>Update</td><td>: ${reading_at}</td></tr>
          <tr><td>Water Level</td><td>: ${water_level}</td></tr>
          <tr><td>Elevasi</td><td>: ${elevation}</td></tr>
        </table>
        <div class="text-end mt-2">
          <a href="/station/detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary">Detail</a>
        </div>
      </div>
    </div>`;
}

function contentPopupAwlr(data) {
  moment.locale("id");
  const lastData = data.lastData.split("|");
  let watershedName =
    data.watershedName == "" || data.watershedName == null
      ? "-"
      : data.watershedName;
  let reading_at = "-";
  if (data.lastReading != null) {
    reading_at = `${moment
      .parseZone(data.lastReading)
      .format("D MMMM YYYY HH:mm")} ${timeZone}`;
  }
  let status = "-";
  let water_level = "-";
  let debit = "-";
  let isOnline = false;
  let status_online = `<span><small class="mdi mdi-circle ${
    data.deviceStatus == "online" ? "text-success" : "text-danger"
  }"></small> ${data.deviceStatus}</span>`;

  if (lastData[0] != "") {
    water_level = `${lastData[0]} <sup>${data.unit}</sup>`;
  }

  if (lastData[1] != "") {
    debit = `${lastData[1]} <sup>m3/s</sup>`;
  }

  switch (parseInt(data.status)) {
    case 0:
      status = '<span class="badge bg-success font-10">NORMAL</span>';
      break;
    case 3:
      status = '<span class="badge bg-warning font-10">WASPADA</span>';
      break;
    case 2:
      status =
        '<span class="badge font-10" style="background-color: rgba(247, 160, 2)">SIAGA</span>';
      break;
    case 1:
      status = '<span class="badge bg-danger font-10">AWAS</span>';
      break;
    default:
      status = "";
      break;
  }

  var contentString = `
                    <div class="table-responsive">
                        <table class="table mb-2 font-12">
                            <tbody>
                                <tr>
                                    <td class="px-0 py-2 pt-1 pe-3" colspan="3">
                                        <div class="d-flex align-items-start">
                                            <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                            <div class="w-100">
                                                <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                                <div class="d-flex align-items-center">
                                                    ${status_online}
                                                    <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                                <div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="py-1 px-0">Sungai</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0">${watershedName}</td>
                                </tr>
                                <tr>
                                    <td class="py-1 px-0">Update</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0">${reading_at}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex justify-content-around align-items-center mb-1 reading-text">
                        <div class="col-4 text-center font-14 fw-bold text-dark">
                            ${water_level}
                        </div>
                        <div class="col-4 text-center font-14 fw-bold text-dark">
                            ${debit}
                        </div>
                        <div class="col-4 text-center font-15 fw-bold text-dark">
                            ${status}
                        </div>
                    </div>
                    <div class="d-flex justify-content-around reading-text mb-2">
                        <div class="col-4 text-center font-12 text-nowrap">
                            TMA
                        </div>
                        <div class="col-4 text-center font-12 text-nowrap">
                            Debit
                        </div>
                        <div class="col-4 text-center font-12 text-nowrap">
                            Status
                        </div>
                    </div>
                    <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
                    `;
  return contentString;
}

function contentPopupAgwlr(data) {
  moment.locale("id");
  const lastData = (data.lastData || "|-|-|-").split("|");
  const watershedName =
    data.watershedName == "" || data.watershedName == null
      ? "-"
      : data.watershedName;
  let reading_at = "-";
  if (data.lastReading != null) {
    reading_at = `${moment
      .parseZone(data.lastReading)
      .format("D MMMM YYYY HH:mm")} ${timeZone}`;
  }

  const parseDecimal = (value) => {
    if (!value) return null;
    const parsed = parseFloat(value.toString().replace(",", "."));
    return isNaN(parsed) ? null : parsed;
  };

  let status = "-";
  switch (parseInt(data.status)) {
    case 0:
      status = '<span class="badge bg-success font-10">NORMAL</span>';
      break;
    case 3:
      status = '<span class="badge bg-warning font-10">WASPADA</span>';
      break;
    case 2:
      status =
        '<span class="badge font-10" style="background-color: rgba(247, 160, 2)">SIAGA</span>';
      break;
    case 1:
      status = '<span class="badge bg-danger font-10">AWAS</span>';
      break;
    default:
      status = "";
      break;
  }

  const status_online = `<span><small class="mdi mdi-circle ${
    data.deviceStatus == "online" ? "text-success" : "text-danger"
  }"></small> ${data.deviceStatus || "Offline"}</span>`;

  const waterLevel = lastData[0]
    ? `${parseDecimal(lastData[0]) ?? lastData[0]} <sup>${data.unit || "m"}</sup>`
    : "-";
  const wellElevationValue =
    parseDecimal(lastData[3]) != null && parseDecimal(lastData[0]) != null
      ? parseDecimal(lastData[3]) - parseDecimal(lastData[0])
      : null;
  const wellElevation =
    wellElevationValue != null
      ? `${wellElevationValue.toFixed(2)} <sup>mdpl</sup>`
      : "-";

  return `
                    <div class="table-responsive">
                        <table class="table mb-2 font-12">
                            <tbody>
                                <tr>
                                    <td class="px-0 py-2 pt-1 pe-3" colspan="3">
                                        <div class="d-flex align-items-start">
                                            <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                            <div class="w-100">
                                                <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                                <div class="d-flex align-items-center">
                                                    ${status_online}
                                                    <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                                <div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="py-1 px-0">Sungai</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0">${watershedName}</td>
                                </tr>
                                <tr>
                                    <td class="py-1 px-0">Update</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0">${reading_at}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex justify-content-around align-items-center mb-1 reading-text">
                        <div class="col-4 text-center font-14 fw-bold text-dark">
                            ${waterLevel}
                        </div>
                        <div class="col-4 text-center font-14 fw-bold text-dark">
                            ${wellElevation}
                        </div>
                        <div class="col-4 text-center font-15 fw-bold text-dark">
                            ${status}
                        </div>
                    </div>
                    <div class="d-flex justify-content-around reading-text mb-2">
                        <div class="col-4 text-center font-12 text-nowrap">MAT</div>
                        <div class="col-4 text-center font-12 text-nowrap">Elv. MAT</div>
                        <div class="col-4 text-center font-12 text-nowrap">Status</div>
                    </div>
                    <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
                    `;
}

function contentPopupArr(data) {
  moment.locale("id");
  let watershedName = data.watershedName == "" ? "-" : data.watershedName;
  let reading_at = "-";
  if (data.lastReading != null) {
    reading_at = `${moment
      .parseZone(data.lastReading)
      .format("D MMMM YYYY HH:mm")} ${timeZone}`;
  }
  let rainfall_hour = "-";
  let intensity_hour = "-";
  let intensity_hour_icon = "-";
  let status_online = `<span><small class="mdi mdi-circle ${
    data.deviceStatus == "online" ? "text-success" : "text-danger"
  }"></small> ${data.deviceStatus}</span>`;

  if (data.lastData != null) {
    rainfall_hour = `${data.lastData} <sup class="text-muted">mm</sup>`;
  }

  if (data.status != null) {
    intensity_hour = getIntensityName(data.status);
    intensity_hour_icon = getIntensityIconMap(data.status);
  }

  var contentString = `
                    <div class="table-responsive">
                        <table class="table mb-2 font-12">
                            <tbody>
                                <tr>
                                    <td class="px-0 py-2 pt-1" colspan="3">
                                        <div class="d-flex align-items-start">
                                            <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                            <div class="w-100">
                                                <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                                <div class="d-flex align-items-center">
                                                    ${status_online}
                                                    <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                                <div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="py-1 px-0">Update</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0">${reading_at}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex justify-content-around align-items-center reading-text">
                        <div class="col-6 text-center font-15 fw-bold text-dark">
                            ${rainfall_hour}
                        </div>
                        <div class="col-6 text-center font-15 fw-bold text-dark">
                            ${intensity_hour_icon}
                        </div>
                    </div>
                    <div class="d-flex justify-content-around reading-text mb-3">
                        <div class="col-6 text-center font-12 text-nowrap">
                            Curah Hujan
                        </div>
                        <div class="col-6 text-center font-12 text-nowrap">
                            ${intensity_hour}
                        </div>
                    </div>
                    <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
                    `;
  return contentString;
}

function contentPopupAwlrArr(data) {
  moment.locale("id");
  const lastData = data.lastData.split("|");
  const lastStatus = data.status.split("|");

  let watershedName = data.watershedName == "" ? "-" : data.watershedName;
  let reading_at = "-";
  if (data.lastReading != null) {
    reading_at = `${moment
      .parseZone(data.lastReading)
      .format("D MMMM YYYY HH:mm")} ${timeZone}`;
  }
  let status = "-";
  let water_level = "-";
  let debit = "-";
  let isOnline = false;
  let status_online = `<span><small class="mdi mdi-circle ${
    data.deviceStatus == "online" ? "text-success" : "text-danger"
  }"></small> ${data.deviceStatus}</span>`;
  let rainfall_hour = "-";
  let intensity_hour = "-";
  let intensity_hour_icon = "-";

  if (lastData[0] != "") {
    //# untuk TMA
    water_level = `${lastData[0]} <sup>${data.unit}</sup>`;
  }

  if (lastData[1] != "") {
    //# untuk Debit
    debit = `${lastData[1]} <sup>m3/s</sup>`;
  }

  switch (parseInt(lastStatus[0] == "" ? 5 : lastStatus[0])) {
    case 0:
      status = '<span class="badge bg-success font-10">NORMAL</span>';
      break;
    case 3:
      status = '<span class="badge bg-warning font-10">WASPADA</span>';
      break;
    case 2:
      status =
        '<span class="badge font-10" style="background-color: rgba(247, 160, 2)">SIAGA</span>';
      break;
    case 1:
      status = '<span class="badge bg-danger font-10">AWAS</span>';
      break;
    default:
      awlr_level_class = "";
      break;
  }

  if (lastData[2] != "") {
    rainfall_hour = `${lastData[2]} <sup class="text-muted">mm</sup>`;
  }

  if (lastStatus[1] != "") {
    intensity_hour = getIntensityName(lastStatus[1]);
    intensity_hour_icon = getIntensityIconMap(lastStatus[1]);
  }

  var contentString = `
                    <div class="table-responsive">
                        <table class="table mb-1 font-12">
                            <tbody>
                                <tr>
                                    <td class="px-0 py-2 pt-1" colspan="3">
                                        <div class="d-flex align-items-start">
                                            <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                            <div class="w-100">
                                                <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                                <div class="d-flex align-items-center">
                                                    ${status_online}
                                                    <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                                <div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="py-1 px-0">Update</td>
                                    <td class="py-1 px-2">:</td>
                                    <td class="py-1 px-0">${reading_at}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex justify-content-around align-items-center reading-text">
                        <div class="col-4 text-center font-15 fw-bold text-dark">
                            ${water_level}
                        </div>
                        <div class="col-4 text-center font-15 fw-bold text-dark">
                            <h4>${debit}</h4>
                        </div>
                        <div class="col-4 text-center font-15 fw-bold text-dark">
                            <h4>${status}</h4>
                        </div>
                    </div>
                    <div class="d-flex justify-content-around reading-text mb-2">
                        <div class="col-4 text-center font-12 text-nowrap">
                            TMA
                        </div>
                        <div class="col-4 text-center font-12 text-nowrap">
                            Debit
                        </div>
                        <div class="col-4 text-center font-12 text-nowrap">
                            Status
                        </div>
                    </div>
                    <div class="d-flex justify-content-around align-items-center reading-text">
                        <div class="col-6 text-center font-15 fw-bold text-dark">
                            ${rainfall_hour}
                        </div>
                        <div class="col-6 text-center font-15 fw-bold text-dark">
                            ${intensity_hour_icon}
                        </div>
                    </div>
                    <div class="d-flex justify-content-around reading-text mb-3">
                        <div class="col-6 text-center font-12 text-nowrap">
                            Curah Hujan
                        </div>
                        <div class="col-6 text-center font-12 text-nowrap">
                            ${intensity_hour}
                        </div>
                    </div>
                    <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
                    `;
  return contentString;
}

/** Urutan lastData AWS: Humidity|Rainfall|Pressure|Temperature|SolarRadiation|WindDirection|WindSpeed|Evaporation|UV */
function isAwsPopupSensorEnabled(data, sensorKey, flagKey) {
  const sensorsRaw = data && data.sensors;
  if (sensorsRaw != null && String(sensorsRaw).trim() !== "") {
    const enabled = String(sensorsRaw)
      .toLowerCase()
      .split(",")
      .map((s) => s.trim().replace(/_/g, ""))
      .filter(Boolean);
    return enabled.includes(String(sensorKey).toLowerCase().replace(/_/g, ""));
  }
  if (flagKey && data && Object.prototype.hasOwnProperty.call(data, flagKey)) {
    return data[flagKey] === true;
  }
  return true;
}

function contentPopupAws(data) {
  moment.locale("id");
  const lastData = data.lastData.split("|");
  const lastStatus = data.status.split("|");

  let watershedName = data.watershedName == "" ? "-" : data.watershedName;
  let reading_at = "-";
  if (data.lastReading != null) {
    reading_at = `${moment
      .parseZone(data.lastReading)
      .format("D MMMM YYYY HH:mm")} ${timeZone}`;
  }
  let status_online = `<span><small class="mdi mdi-circle ${
    data.deviceStatus == "online" ? "text-success" : "text-danger"
  }"></small> ${data.deviceStatus}</span>`;

  const intensity = {
    0: "Tidak ada Hujan",
    1: "Hujan Ringan",
    2: "Hujan Sedang",
    3: "Hujan Lebat",
    4: "Hujan sangat Lebat",
  };

  var sensorReadings = "";
  if (isAwsPopupSensorEnabled(data, "humidity", "isHumidity") && lastData[0] != "") {
    sensorReadings += `<tr>
            <td class="py-1 px-0">Kelembapan</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0"><span class="text-dark fw-semibold">${lastData[0]}% </span> <small class="text-muted">(${lastStatus[0]})</small></td>
        </tr>`;
  }

  if (isAwsPopupSensorEnabled(data, "rainfall", "isRainfall") && lastData[1] != "") {
    sensorReadings += `<tr>
            <td class="py-1 px-0">Curah Hujan</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0"><span class="text-dark fw-semibold">${
              lastData[1]
            } <sup>mm</sup> </span> <small class="text-muted">(${
      intensity[lastStatus[1]]
    })</small></td>
        </tr>`;
  }

  if (isAwsPopupSensorEnabled(data, "pressure", "isPressure") && lastData[2] != "") {
    sensorReadings += `<tr>
            <td class="py-1 px-0">Tekanan</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0"><span class="text-dark fw-semibold">${lastData[2]}</span> <small class="text-muted">MB</small></td>
        </tr>`;
  }

  if (isAwsPopupSensorEnabled(data, "temperature", "isTemperature") && lastData[3] != "") {
    sensorReadings += `<tr>
            <td class="py-1 px-0">Suhu</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0"><span class="text-dark fw-semibold">${lastData[3]}</span> <small class="text-muted">&deg;C</small></td>
        </tr>`;
  }

  if (isAwsPopupSensorEnabled(data, "solarradiation", "isSolarRadiation") && lastData[4] != "") {
    var sunshineHour = "";

    // if(data.sunshineHour != '') {
    //     sunshineHour = `<span class="text-dark fw-semibold">${data.sunshineHour} <small class="text-muted">Jam</small>`;
    // }
    sensorReadings += `<tr>
            <td class="py-1 px-0">Radiasi Matahari</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0">
                <span class="text-dark fw-semibold">${lastData[4]}</span>
            </td>
        </tr>`;
  }

  if (isAwsPopupSensorEnabled(data, "winddirection", "isWindDirection") && lastData[5] != "") {
    sensorReadings += `<tr>
            <td class="py-1 px-0">Arah Angin</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0">
                <span class="text-dark fw-semibold me-1">${lastData[5]}&deg;</span>
                <small>
                    <span style="transform: rotate(${lastData[5]}deg);"><i class="mdi mdi-navigation"></i></span>
                    <span>${lastStatus[2]}</span>
                </small>
            </td>
        </tr>`;
  }

  if (isAwsPopupSensorEnabled(data, "windspeed", "isWindSpeed") && lastData[6] != "") {
    sensorReadings += `<tr>
            <td class="py-1 px-0">Kec. Angin</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0"><span class="text-dark fw-semibold">${lastData[6]}</span> <small class="text-muted">km/h</small></td>
        </tr>`;
  }

  if (isAwsPopupSensorEnabled(data, "evaporation", "isEvaporation") && lastData[7] != "") {
    sensorReadings += `<tr>
            <td class="py-1 px-0">Tinggi Penguapan</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0"><span class="text-dark fw-semibold">${lastData[7]}</span> <small class="text-muted">mm</small></td>
        </tr>`;
  }

  if (isAwsPopupSensorEnabled(data, "uv", "isUv") && lastData[8] != null && lastData[8] !== "") {
    sensorReadings += `<tr>
            <td class="py-1 px-0">UV</td>
            <td class="py-1 px-2">:</td>
            <td class="py-1 px-0"><span class="text-dark fw-semibold">${lastData[8]}</span></td>
        </tr>`;
  }

  var contentString = `
        <div class="table-responsive">
            <table class="table mb-2 font-12">
                <tbody>
                    <tr>
                        <td class="px-0 py-2 pt-1" colspan="3">
                            <div class="d-flex align-items-start">
                                <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                <div class="w-100">
                                    <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                    <div class="d-flex align-items-center">
                                        ${status_online}
                                        <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                    <div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="py-1 px-0">Update</td>
                        <td class="py-1 px-2">:</td>
                        <td class="py-1 px-0">${reading_at}</td>
                    </tr>
                    ${sensorReadings}
                </tbody>
            </table>
        </div>
        <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
        `;

  return contentString;
}

function contentPopupVNotch(data) {
  return "";
}

function contentPopupFlowMeter(data) {
  moment.locale("id");
  const lastData = data.lastData.split("|");
  const lastStatus = data.status.split("|");

  let watershedName = data.watershedName == "" ? "-" : data.watershedName;
  let reading_at = "-";
  if (data.lastReading != null) {
    reading_at = `${moment
      .parseZone(data.lastReading)
      .format("D MMMM YYYY HH:mm")} ${timeZone}`;
  }
  let status = "-";
  let debit_1jam = "-";
  let debit_total = "-";
  let isOnline = false;
  let status_online = `<span><small class="mdi mdi-circle ${
    data.deviceStatus == "online" ? "text-success" : "text-danger"
  }"></small> ${data.deviceStatus}</span>`;

  if (lastData[0] != "") {
    debit_1jam = `${lastData[0]} <sup>m<sup>3</sup>/s</sup>`;
  }

  if (lastData[1] != "") {
    debit_1jam = `${lastData[1]} <sup>m<sup>3</sup></sup>`;
  }

  var contentString = `
            <div class="table-responsive">
                <table class="table mb-2 font-12">
                    <tbody>
                        <tr>
                            <td class="px-0 py-2 pt-1 pe-3" colspan="3">
                                <div class="d-flex align-items-start">
                                    <img class="me-2 rounded-3" src="/images/defaults/${defaultImage}" width="35" height="35" alt="${data.name}">
                                    <div class="w-100">
                                        <h5 class="mt-0 mb-1 fw-bold font-12" style="color: #2A62A6;">${data.name}</h5>
                                        <div class="d-flex align-items-center">
                                            ${status_online}
                                            <span class="badge badge-outline-secondary rounded-1 ms-1">${data.deviceId}</span>
                                        <div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="py-1 px-0">Sungai</td>
                            <td class="py-1 px-2">:</td>
                            <td class="py-1 px-0">${watershedName}</td>
                        </tr>
                        <tr>
                            <td class="py-1 px-0">Update</td>
                            <td class="py-1 px-2">:</td>
                            <td class="py-1 px-0">${reading_at}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-around align-items-center mb-1 reading-text">
                <div class="col-4 text-center font-14 fw-bold text-dark">
                    ${debit_1jam}
                </div>
                <div class="col-4 text-center font-14 fw-bold text-dark">

                </div>
                <div class="col-4 text-center font-15 fw-bold text-dark">
                    ${debit_total}
                </div>
            </div>
            <div class="d-flex justify-content-around reading-text mb-2">
                <div class="col-4 text-center font-12 text-nowrap">
                    Flow Rate
                </div>
                <div class="col-4 text-center font-12 text-nowrap">

                </div>
                <div class="col-4 text-center font-12 text-nowrap">
                    Totalizer
                </div>
            </div>
            <a href="/Station/Detail/${data.slug}" target="_blank" class="btn btn-sm btn-primary rounded-pill waves-effect waves-light text-white w-100">Lihat Detail</a>
    `;
  return contentString;
}

function calculateCapacity(voltage) {
  if (voltage < 11) {
    return 0; // Kapasitas 0% jika tegangan kurang dari 11V
  }
  if (voltage < 13) {
    return Math.round(((voltage - 11) / (13 - 11)) * 100);
    // Kapasitas dari 0% hingga 100% pada rentang 11V - 13V
  } else if (voltage > 13) {
    return 100;
  }
  return 0;
}

/** Sensor AWS disabled di DB → tampilkan "-", jangan pakai last reading. */
function isAwsSensorEnabled(row, flagKey) {
  return row && row[flagKey] === true;
}

function renderAwsSensorCell(data, row, flagKey) {
  if (!isAwsSensorEnabled(row, flagKey)) {
    return "-";
  }
  if (data == null || data === "") {
    return "-";
  }
  return data;
}

function loadAwsTable() {
  const formData = new FormData();

  $.ajax({
    type: "POST",
    url: "/Home/GetDatatableAwsLastReading",
    data: formData,
    contentType: false,
    processData: false,
    success: function (response) {
      const sensors = (response.sensors || [])
        .filter((s) => typeof s === "string")
        .map((s) => s.toLowerCase());

      generateAwsHeader(sensors);
      generateAwsTable(response.data, sensors);
      console.log(sensors);
    },
    error: function (xhr, status, error) {
      console.error("Load AWS error:", error);
    },
  });
}

function generateAwsHeader(sensors) {
  const thead = $("#aws-table thead");
  thead.empty();

  const sensorsLower = (sensors || []).map((s) => s.toLowerCase());

  const hasRainfall = sensorsLower.includes("rainfall");
  const hasSolar = sensorsLower.includes("solarradiation");

  const row1 = $("<tr>");
  const row2 = $("<tr>");

  // Kolom statis
  row1.append(`<th rowspan="2" class="text-center">No.</th>`);
  row1.append(`<th rowspan="2">Nama Pos</th>`);
  row1.append(`<th rowspan="2" class="text-center">Tanggal</th>`);
  row1.append(`<th rowspan="2" class="text-center">Jam</th>`);
  if (sensorsLower.includes("humidity")) {
    row1.append(`<th rowspan="2" class="text-center">Kelembapan</th>`);
  }

  // Kolom Rainfall
  if (hasRainfall) {
    row1.append(`<th colspan="2" class="text-center">Curah Hujan</th>`);
    row2.append(`<th class="text-center"><small>Per 5 Menit</small></th>`);
    row2.append(`<th class="text-center"><small>1 Jam Terakhir</small></th>`);
  }

  // Tekanan
  if (sensorsLower.includes("pressure")) {
    row1.append(
      `<th rowspan="2" class="text-center">Tekanan<br><small class="text-muted">(MB)</small></th>`
    );
  }

  // Kolom Radiasi
  if (hasSolar) {
    row1.append(`<th colspan="2" class="text-center">Radiasi Matahari</th>`);
    row2.append(
      `<th class="text-center"><small>Radiasi <span class="text-muted">(W/m²)</span></small></th>`
    );
    row2.append(
      `<th class="text-center"><small>Lama Penyinaran <span class="text-muted">(hours)</span></small></th>`
    );
  } else if (sensorsLower.includes("solarradiation")) {
    row1.append(
      `<th rowspan="2" class="text-center">Radiasi Matahari<br><small class="text-muted">(W/m²)</small></th>`
    );
  }

  // Kolom-kolom dinamis berdasarkan sensor
  const sensorColumns = [
    {
      key: "temperature",
      label: `Suhu<br><small class="text-muted">(&deg;C)</small>`,
    },
    { key: "winddirection", label: "Arah Angin" },
    {
      key: "windspeed",
      label: `Kecepatan Angin<br><small class="text-muted">(km/h)</small>`,
    },
    {
      key: "evaporation",
      label: `Tinggi Penguapan<br><small class="text-muted">(mm)</small>`,
    },
    {
      key: "uv",
      label: `Ultraviolet<br><small class="text-muted">(nm)</small>`,
    },
  ];

  sensorColumns.forEach((col) => {
    if (sensorsLower.includes(col.key)) {
      row1.append(`<th rowspan="2" class="text-center">${col.label}</th>`);
    }
  });

  // Kolom baterai wajib ada
  if (USE_BATTERY_COLUMN) {
    row1.append(
      `<th rowspan="2" class="text-center">Baterai<br><small class="text-muted">(Volt)</small></th>`
    );
  }

  thead.append(row1);
  if (row2.children().length > 0) {
    thead.append(row2);
  }
}

function generateAwsTable(data, sensors) {
  const hasRainfall = sensors.includes("rainfall");
  const hasSolar = sensors.includes("solarradiation");
  const hasHumidity = sensors.includes("humidity");
  const hasPressure = sensors.includes("pressure");
  const hasTemperature = sensors.includes("temperature");
  const hasWindirection = sensors.includes("winddirection");
  const hasWindSpeed = sensors.includes("windspeed");
  const hasEvaporation = sensors.includes("evaporation");
  const hasUV = sensors.includes("uv");

  const columns = [
    {
      data: null,
      render: (data, type, row, meta) => `${meta.row + 1}`,
      className: "text-center",
    },
    {
      data: "name",
      name: "name",
      className: "text-nowrap",
      render: function (data, type, row) {
        if (row.deviceStatus == "offline") {
          return `<i class="mdi mdi-alert-circle-outline me-1"></i><a href="/Station/Detail/${row.slug}" target="_blank" class="text-danger fw-semibold" title="Offline" tabindex="0" data-plugin="tippy" data-tippy-animation="shift-away" data-tippy-arrow="true">${data}</a>`;
        }

        return `<a href="/Station/Detail/${row.slug}" target="_blank" class="text-blue fw-semibold">${data}</a>`;
      },
    },
    {
      data: "readingAt",
      name: "readingAt",
      className: "text-center text-nowrap",
      render: function (data, type, row) {
        if (data != null) {
          return `${moment.parseZone(data).locale("id").format("D MMMM YYYY")}`;
        }

        return "-";
      },
    },
    {
      data: "readingAt",
      name: "readingAt",
      className: "text-center text-nowrap",
      render: function (data, type, row) {
        if (data != null) {
          return `${moment.parseZone(data).locale("id").format("HH:mm")}`;
        }

        return "-";
      },
    },
  ];

  if (hasHumidity) {
    columns.push({
      data: "humidity",
      name: "humidity",
      className: "text-center",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isHumidity")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}%</span><br/><small class="text-muted">${row.humidityStatus || ""}</small>`;
      },
    });
  }

  if (hasRainfall) {
    columns.push({
      data: "rainfall",
      name: "rainfall",
      className: "text-center text-nowrap",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isRainfall")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data} <small>mm</small></span>`;
      },
    });
    columns.push({
      data: "intensityLastHour",
      name: "intensityLastHour",
      className: "text-center text-nowrap",
      createdCell: function (td, cellData, rowData, row, col) {
        if (!isAwsSensorEnabled(rowData, "isRainfall")) {
          return;
        }
        switch (cellData) {
          case 0:
            $(td).addClass("bg-berawan");
            break;

          case 1:
            $(td).addClass("bg-hujan-ringan");
            break;

          case 2:
            $(td).addClass("bg-hujan-sedang");
            break;

          case 3:
            $(td).addClass("bg-hujan-lebat");
            break;
          case 4:
            $(td).addClass("bg-hujan-sangat-lebat");
            break;
        }
      },
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isRainfall")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${
          row.rainfallLastHour
        } <small>mm</small></span><br/><small class="text-dark">${getIntensityName(
          data
        )}</small>`;
      },
    });
  }

  if (hasPressure) {
    columns.push({
      data: "pressure",
      name: "pressure",
      className: "text-center",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isPressure")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}</span>`;
      },
    });
  }

  if (hasSolar) {
    columns.push({
      data: "solarRadiation",
      name: "solarRadiation",
      className: "text-center",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isSolarRadiation")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}</span>`;
      },
    });
    columns.push({
      data: "sunshineHour",
      name: "sunshineHour",
      className: "text-center",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isSolarRadiation")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}</span>`;
      },
    });
  }

  if (hasTemperature) {
    columns.push({
      data: "temperature",
      name: "temperature",
      className: "text-center",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isTemperature")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}</span>`;
      },
    });
  }

  if (hasWindirection) {
    columns.push({
      data: "windDirection",
      name: "windDirection",
      className: "text-center text-nowrap",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isWindDirection")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}&deg;</span><br/>
                    <small class="d-flex justify-content-center align-items-center text-muted">
                        <span style="transform: rotate(${data}deg);"><i class="mdi mdi-navigation"></i></span>
                        <span class="ms-1">${row.windDirectionStatus || ""}</span>
                    </small>`;
      },
    });
  }

  if (hasWindSpeed) {
    columns.push({
      data: "windSpeed",
      name: "windSpeed",
      className: "text-center",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isWindSpeed")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}</span>`;
      },
    });
  }

  if (hasEvaporation) {
    columns.push({
      data: "evaporation",
      name: "evaporation",
      className: "text-center",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isEvaporation")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}</span>`;
      },
    });
  }

  if (hasUV) {
    columns.push({
      data: "uv",
      name: "uv",
      className: "text-center",
      render: function (data, type, row) {
        if (!isAwsSensorEnabled(row, "isUv")) {
          return "-";
        }
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}</span>`;
      },
    });
  }

  // Baterai wajib ditampilkan
  if (USE_BATTERY_COLUMN) {
    columns.push({
      data: "battery",
      name: "battery",
      className: "text-center",
      render: function (data, type, row) {
        if (data == null) {
          return "-";
        }

        return `<span class="text-dark fw-semibold">${data}</span>`;
      },
    });
  }

  $("#aws-table").DataTable({
    destroy: true,
    data: data,
    columns: columns,
    ordering: false,
    searching: false,
    paging: false,
    info: false,
  });
}

function formatNumber(num) {
  if (num == null || num === "") return "";
  const number = typeof num === "string" ? parseFloat(num) : num;
  return number.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
